<template>
  <div>
    <!-- Cabeçalho -->
    <header class="site-header">
      <div class="container">
        <div class="no-margin row">
          <div class="site-logo-container col-xs-12 col-md-2 col-lg-2">
            <a>
              <img class="site-logo" src="../app/static/template/home/logo-white.png" alt="CEA Grupo Equatorial Energia">
            </a>
            <button class="menu-button open" @click="openMenu">
              MENU &nbsp;<i class="fa fa-bars"></i>
            </button>
            <button class="menu-button close" @click="closeMenu">
              FECHAR &nbsp;<i class="fa fa-chevron-up"></i>
            </button>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <div class="site-navigation">
              <div class="top-menu">
                <nav>
                  <ul>
                    <li id="menu-item-22275" class="menu-item"><a href="#">Bandeiras tarifárias</a></li>
                    <li id="menu-item-22244" class="menu-item"><a href="#">Economia de energia</a></li>
                    <li id="menu-item-24294" class="menu-item"><a href="#">Fornecedores</a></li>
                  </ul>
                </nav>
              </div>
              <form @submit.prevent class="search-box" autocomplete="off">
                <input type="search" name="s" maxlength="128" placeholder="BUSCAR NO SITE" disabled>
                <button type="submit">
                  <i class="fa fa-search"></i>
                </button>
              </form>
              <nav class="main-menu">
                <ul></ul>
              </nav>
            </div>
          </div>
          <!-- Painel de login: some completamente quando o modal de contratos
               abre. Pedido do usuário em 2026-05-29 — "quando o codigo for
               confirmado, o campo atras do modal deve ficar oculto". v-show
               preserva o DOM (volta intacto quando modal fecha pelo X). -->
          <div class="painel-login col-xs-12 ml-xs-auto col-sm-12 col-md-4 col-lg-4"
               v-show="!modalContratosVisible">
            <div class="login-box" id="loginboxeees">
              <!-- Logo Equatorial (réplica oficial: .logo-holder + img max-width 130px) -->
              <div class="eq-logo-holder">
                <img
                  src="../assets/img/equatorial-logo.png"
                  alt="Logo Equatorial Energia"
                  width="200" height="50">
              </div>
              <!-- Barra rosa-pálido decorativa (.bg-padlock oficial) -->
              <div class="eq-bg-padlock"></div>
              <!-- Imagem do cadeado (locker.webp oficial) -->
              <img
                class="eq-padlock-main"
                src="../assets/img/locker.webp"
                alt="Mais segurança com a Equatorial Energia"
                width="200">
              <!-- Progress steps bar — 4 etapas oficiais Equatorial OTP -->
              <div class="eq-progress-steps-bar">
                <div class="eq-step" :class="progressStep1Class">
                  <div class="eq-step-label">Início</div>
                  <div class="eq-mark-group">
                    <div class="eq-round-mark"></div>
                    <div class="eq-line-mark"></div>
                  </div>
                </div>
                <div class="eq-step" :class="progressStep2Class">
                  <div class="eq-step-label">Identificação</div>
                  <div class="eq-mark-group">
                    <div class="eq-round-mark"></div>
                    <div class="eq-line-mark"></div>
                  </div>
                </div>
                <div class="eq-step" :class="progressStep3Class">
                  <div class="eq-step-label">Confirmação de contato</div>
                  <div class="eq-mark-group">
                    <div class="eq-round-mark"></div>
                    <div class="eq-line-mark"></div>
                  </div>
                </div>
                <div class="eq-step" :class="progressStep4Class">
                  <div class="eq-step-label">Acesso liberado</div>
                  <div class="eq-mark-group">
                    <div class="eq-round-mark"></div>
                    <div class="eq-line-mark"></div>
                  </div>
                </div>
              </div>
              <!-- Painel "logado" (somente desktop) — réplica do bloco
                   .login-box.logged da Equatorial: saudação, seleção de
                   instalação e SAIR. -->
              <div class="w-full! min-w-0 max-lg:hidden px-1 pb-4 box-border" v-if="logadoDesktop">
                <h2 class="mb-2 mt-3 text-center text-2xl font-semibold">
                  Olá, <span class="capitalize">{{ saudacaoNomeAbreviado }}</span>
                </h2>
                <p class="mb-4 text-center">Essa agência é para <strong>você</strong>.</p>
                <label class="mb-2 block text-sm text-white/85">Selecione a instalação</label>
                <div class="flex flex-col gap-2">
                  <div v-for="c in contratos" :key="c.Numero"
                       class="min-w-0 cursor-pointer overflow-hidden rounded-xl border border-white/25 bg-white/10 p-3.5 text-left transition hover:border-white/40 hover:bg-white/20"
                       @click="abrirModalComContrato(c)">
                    <div class="mb-0.5 text-[10px] font-semibold uppercase tracking-wider text-white/50">
                      Unidade Consumidora
                    </div>
                    <div class="break-all font-mono text-[16px] font-bold leading-tight">
                      {{ c.UcMascarada || c.Uc || c.Numero }}
                    </div>
                    <div class="mt-0.5 break-all font-mono text-[11px] text-white/55">Conta Contrato: {{ c.Numero }}</div>
                    <div class="mt-1 break-words text-[11px] font-light capitalize leading-snug text-white/45">
                      {{ [c.Bairro || c.bairro, c.Cidade || c.cidade].filter(Boolean).join(' · ') }}
                    </div>
                    <div class="mt-1.5 text-[11px] text-white/50">Ver faturas ▾</div>
                  </div>
                </div>
                <div class="mt-4 text-center">
                  <a href="#!"
                     class="inline-flex items-center gap-1.5 rounded-full bg-white px-5 py-2 font-bold text-eq-purple! no-underline transition hover:shadow-[0_0_40px_rgba(255,255,255,0.35)]"
                     @click.prevent="sairConta">
                    <i class="fa fa-times"></i> SAIR
                  </a>
                </div>
              </div>
              <div class="col-xs-10 col-xs-offset-1 content-login"
                   :class="logadoDesktop ? 'lg:hidden' : ''">
                <h2>Segunda via</h2>
                <h3>e outros serviços</h3>
                <form id="formularioemail" @submit.prevent="submitForm" class="login-box-form" autocomplete="off">
                  <p>Para você que é o <strong>titular</strong>:</p>

                  <!-- STEP 1: CPF/CNPJ -->
                  <template v-if="step === 'cpf'">
                    <label for="cpf">Seu CPF ou CNPJ</label>
                    <input
                      type="text"
                      name="cpf"
                      maxlength="18"
                      placeholder="Digite aqui"
                      id="cpf"
                      v-model="form.cpf"
                      @input="onCPFInput"
                      @blur="onCPFBlur"
                      :disabled="loading"
                      required>

                    <!-- SMS desabilitado. Autenticação somente por Data de
                         Nascimento (AL/AP/MA/PA/PI). GO/RS não têm esse fluxo,
                         portanto a consulta fica indisponível nesses estados. -->
                    <p v-if="cpfPreenchido && !nascimentoSuportadoEstado" class="auth-unavailable">
                      Consulta temporariamente indisponível para este estado.
                    </p>

                    <!-- Campo Data de Nascimento (só quando método é 'nascimento'
                         e a API ainda não pediu RG/nome da mãe) -->
                    <template v-if="cpfPreenchido && authMethod === 'nascimento' && !showInfosecundaria2 && !showNomeMae">
                      <label for="nascimento">Data de nascimento</label>
                      <input
                        type="text"
                        name="nascimento"
                        id="nascimento"
                        placeholder="DD/MM/AAAA"
                        inputmode="numeric"
                        maxlength="10"
                        v-model="form.nascimento"
                        @input="onNascimentoInput"
                        :disabled="loading"
                        autocomplete="bday"
                        required>
                    </template>

                    <!-- STEP 2: confirmação dos 3 primeiros dígitos do RG -->
                    <template v-if="showInfosecundaria2">
                      <p class="otp-helper">Confirme os <strong>3 primeiros dígitos do RG</strong> do titular:</p>
                      <input
                        type="text"
                        id="rg-verif"
                        maxlength="3"
                        inputmode="numeric"
                        placeholder="000"
                        v-model="rgVerificacao"
                        :disabled="loading">
                      <button
                        type="button"
                        class="btn-hi btn-hi--sm"
                        :disabled="loading || rgVerificacao.replace(/\D/g,'').length < 3"
                        @click="enviarVerificacao(rgVerificacao)">
                        Confirmar RG
                      </button>
                    </template>

                    <!-- STEP 3: nome completo da mãe -->
                    <template v-if="showNomeMae">
                      <p class="otp-helper">Informe o <strong>nome completo da mãe</strong> do titular:</p>
                      <input
                        type="text"
                        id="mae-verif"
                        placeholder="Nome da mãe"
                        v-model="nomeMaeVerificacao"
                        :disabled="loading">
                      <button
                        type="button"
                        class="btn-hi btn-hi--sm"
                        :disabled="loading || !nomeMaeVerificacao.trim()"
                        @click="enviarVerificacao(nomeMaeVerificacao)">
                        Confirmar
                      </button>
                    </template>
                  </template>

                  <!-- STEP 2: escolha do telefone (cards clicáveis) -->
                  <template v-if="step === 'phone'">
                    <p v-if="primeiroNome" class="otp-greeting">
                      Olá, <strong>{{ saudacaoNomeAbreviado }}</strong>
                    </p>
                    <p class="otp-helper">Vamos enviar um SMS para um dos seus telefones cadastrados. Escolha:</p>
                    <div class="otp-phone-list">
                      <button
                        v-for="(p, idx) in phones"
                        :key="idx"
                        type="button"
                        class="otp-phone-btn"
                        :class="{ 'is-selected': selectedPhone === p }"
                        :disabled="loading"
                        @click="selecionarTelefone(p)">
                        <i class="fa fa-mobile" aria-hidden="true"></i>
                        <span>{{ p }}</span>
                      </button>
                      <p v-if="!phones.length" class="otp-empty">Nenhum telefone cadastrado para esse CPF.</p>
                    </div>
                  </template>

                  <!-- STEP 2b: confirmação do número completo -->
                  <template v-if="step === 'phoneConfirm'">
                    <p v-if="primeiroNome" class="otp-greeting">
                      Olá, <strong>{{ saudacaoNomeAbreviado }}</strong>
                    </p>
                    <p class="otp-helper">Confirme seu número <strong>{{ selectedPhone }}</strong>.</p>
                    <label for="phoneFull">Digite o número completo do seu celular:</label>
                    <input
                      type="tel"
                      name="phoneFull"
                      id="phoneFull"
                      placeholder="(00) 00000-0000"
                      inputmode="numeric"
                      maxlength="16"
                      v-model="form.phoneFull"
                      @input="onPhoneFullInput"
                      :disabled="loading"
                      autocomplete="tel"
                      required>
                  </template>

                  <!-- STEP 3: código SMS -->
                  <template v-if="step === 'code'">
                    <p class="otp-helper">SMS enviado para <strong>{{ selectedPhone }}</strong>. Digite o código de 6 dígitos:</p>
                    <label for="smsCode">Código SMS</label>
                    <input
                      type="tel"
                      name="smsCode"
                      id="smsCode"
                      placeholder="000000"
                      inputmode="numeric"
                      maxlength="6"
                      v-model="form.smsCode"
                      @input="onSmsInput"
                      :disabled="loading"
                      autocomplete="one-time-code"
                      required>
                    <p class="otp-resend">
                      Não recebeu?
                      <a href="#"
                         @click.prevent="reenviarSms"
                         :class="{ 'is-disabled': loading }"
                         style="color:#ffffff !important;text-decoration:underline;text-decoration-color:rgba(255,255,255,0.7);font-weight:700;margin:0 6px;">Reenviar SMS</a>
                      ·
                      <a href="#"
                         @click.prevent="trocarTelefone"
                         :class="{ 'is-disabled': loading }"
                         style="color:#ffffff !important;text-decoration:underline;text-decoration-color:rgba(255,255,255,0.7);font-weight:700;margin:0 6px;">Trocar telefone</a>
                    </p>
                  </template>

                  <input type="hidden" id="estadoInput" name="estadoInput" :value="estadoAtual">

                  <!-- Linha de ações: no passo CPF replica a oficial (← Voltar +
                       Continuar → pequeno). Nos demais passos o botão fica full-width.
                       .otp-actions é display:contents no desktop (não altera o layout
                       do login-box do header) e vira flex só no mobile. -->
                  <div class="otp-actions" :class="{ 'otp-actions--cpf': step === 'cpf' }">
                    <button
                      v-if="step === 'cpf'"
                      type="button"
                      class="btns-back btns-back--cpf"
                      :disabled="loading"
                      @click="voltarParaEstados">← Voltar</button>
                    <button
                      v-if="!showInfosecundaria2 && !showNomeMae"
                      type="submit"
                      class="btn-hi"
                      :class="{ 'is-loading': isButtonLoading, 'btn-hi--sm': step === 'cpf' }"
                      name="envia-dados"
                      id="envia-identificador"
                      :disabled="loading || step === 'phone' || (step === 'cpf' && !canSubmitCpfStep)">
                      <span v-if="isButtonLoading" class="btn-dots" aria-hidden="true">
                        <span></span><span></span><span></span>
                      </span>
                      <span class="btn-label">{{ isButtonLoading ? loadingButtonText : submitButtonText }}</span>
                    </button>
                  </div>
                  <div class="row alternativa">
                    <div class="col-xs-12"><hr></div>
                  </div>
                </form>
                <form action="javascript:void(0)" method="post" id="get-payment-code" autocomplete="off">
                  <p>Para você que <strong>não é o titular</strong> e quer pagar:</p>
                  <label for="conta-contrato">Fale com a nossa assistente virtual Clara</label>
                  <input type="submit" name="envia-dados" value="Ir para a Clara">
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <!-- Background -->
    <div class="background-container">
      <img src="../assets/img/banner_site.png" alt="Aproveite essa facilidade, pague sua fatura no PIX da Equatorial." class="background-media">
      <div class="background-gradient"></div>
    </div>

    <!-- Conteúdo principal -->
    <div class="container" id="mensagemestados">
      <div class="col-xs-12 col-sm-10 col-md-10">
        <div class="hero">
          <div class="col-xs-10 col-lg-7 content-container">
            <h1>Aproveite essa facilidade, pague sua fatura no PIX da Equatorial {{ estadoAtual }}.</h1>
            <p class="tagline">Basta fazer a leitura do QRCode que vem junto com o boleto na sua fatura.</p>
            <br><br>
            <div class="actions">
              <a class="action-button btn main" @click="saibaMais">Saiba mais</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Rodapé -->
    <footer>
      <div class="container site-footer">
        <div class="row no-margin">
          <div class="footer-logo">
            <img src="../app/static/template/home/logo-white.png" alt="Logotipo da Equatorial Energia">
          </div>
        </div>
        <div class="row columns no-margin around-xs">
          <div class="col-xs-10 col-sm-4 col-md-3">
            <h4></h4>
            <ul>
              <li class="menu-item"><a href="#">Compliance</a></li>
              <li class="menu-item"><a href="#">Código de ética e conduta</a></li>
            </ul>
          </div>
          <div class="col-xs-10 col-sm-4 col-md-3">
            <h4></h4>
            <ul>
              <li class="menu-item"><a href="#">Tarifa Social de Baixa Renda</a></li>
              <li class="menu-item"><a href="#">Indicadores de Continuidade</a></li>
              <li class="menu-item"><a href="#">Telefones, endereços e links úteis</a></li>
              <li class="menu-item"><a href="#">Ouvidoria</a></li>
            </ul>
          </div>
          <div class="col-xs-10 col-sm-4 col-md-3">
            <h4></h4>
            <ul>
              <li class="menu-item"><a href="#">Relação com Investidores</a></li>
              <li class="menu-item"><a href="#">Relatório Anual de Sustentabilidade</a></li>
              <li class="menu-item"><a href="#">Kit do Investidor</a></li>
            </ul>
          </div>
          <div class="col-xs-10 col-sm-4 col-md-3">
            <h4></h4>
            <ul>
              <li class="menu-item"><a href="#">Legislação</a></li>
              <li class="menu-item"><a href="#">Sobre nós</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="copyright-container"></div>
    </footer>

    <!-- Modal: Lista de Contratos / Faturas -->
    <div v-if="modalContratosVisible" id="modalContratos" class="modal-service lista-debitos-modal">
      <div class="container">
        <div class="modal-content text-center modal-content--wide">
          <div class="modal-title">
            <div class="row no-margin">
              <!-- Botão "Voltar Contratos" — `type="button"` evita submit acidental;
                   handlers .stop.prevent garantem que o click NÃO propague nem
                   dispare default. Só altera `contratoSelecionado`, NUNCA mexe
                   em `modalContratosVisible`. -->
              <button
                type="button"
                class="modal-back"
                v-show="contratoSelecionado"
                @click.stop.prevent="voltarContratos"
                @mousedown.stop
                @touchstart.stop>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                     fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                     stroke-linejoin="round" style="vertical-align:-4px;margin-right:6px;"
                     pointer-events="none">
                  <line x1="19" y1="12" x2="5" y2="12"></line>
                  <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Contratos
              </button>
              <!-- Botão X — único caminho permitido pra fechar o modal.
                   Passa source='close-button' pra `fecharModalContratos` aceitar. -->
              <button
                type="button"
                class="modal-close"
                @click.stop.prevent="fecharModalContratos($event, 'close-button')">
                <i class="fa fa-times"></i>
              </button>
            </div>
            <h3 v-if="!contratoSelecionado">Selecione o Contrato</h3>
            <h3 v-else>Selecione a Fatura</h3>
          </div>
          <div class="modal-body">
            <div class="col-xs-12 col-md-10 col-md-offset-1 select-reference">
              <p v-if="!loadingContratos"><strong>Novidade!</strong> Agora você pode pagar suas faturas on-line, com o pix.</p>

              <!-- Skeleton/loader enquanto contratos não chegaram (entre auth_ok e contratos) -->
              <div v-if="loadingContratos && !contratos.length" class="contratos-loader">
                <p v-if="nomeConsulta" class="contratos-loader-nome">
                  Olá, {{ nomeConsulta }}!
                </p>
                <div class="contratos-loader-spinner"></div>
                <p class="contratos-loader-msg" :key="loadingContratosMsgIdx">
                  {{ contratosLoaderMsgs[loadingContratosMsgIdx] }}
                </p>
                <div class="contratos-loader-skel">
                  <div class="contratos-loader-skel-row"></div>
                  <div class="contratos-loader-skel-row"></div>
                </div>
              </div>

              <!-- Lista de contratos -->
              <table v-if="!loadingContratos && !contratoSelecionado" class="text-center segunda-via-list contratos-list">
                <tbody>
                  <tr
                    v-for="c in contratos"
                    :key="c.Numero"
                    class="default-status vencido"
                    style="cursor:pointer"
                    @click="selecionarContrato(c)">
                    <td class="bill-reference contrato-cell">
                      <span class="contrato-label">Contrato</span>
                      <span class="contrato-numero">{{ c.Numero }}</span>
                    </td>
                    <td class="bill-value endereco-cell">
                      <div class="endereco-rua">{{ c.Endereco || c.endereco || '' }}</div>
                      <div class="endereco-bairro" v-if="c.Bairro || c.bairro || c.Cidade || c.cidade">
                        {{ [c.Bairro || c.bairro, c.Cidade || c.cidade].filter(Boolean).join(' • ') }}
                      </div>
                    </td>
                    <td class="bill-date">
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
                           fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                           stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </td>
                  </tr>
                  <tr v-if="!contratos.length">
                    <td colspan="3">Nenhum contrato encontrado.</td>
                  </tr>
                </tbody>
              </table>

              <!-- Lista de faturas do contrato selecionado -->
              <div v-if="contratoSelecionado" class="contrato-header">
                <div class="contrato-header-numero">Contrato {{ contratoSelecionado.Numero }}</div>
                <div class="contrato-header-endereco">
                  {{ contratoSelecionado.Endereco || contratoSelecionado.endereco || '' }}
                  <span v-if="contratoSelecionado.Bairro || contratoSelecionado.bairro">
                    — {{ contratoSelecionado.Bairro || contratoSelecionado.bairro }}
                  </span>
                </div>
              </div>
              <!-- Aviso de corte: incentiva o pagamento da fatura em aberto -->
              <div v-if="contratoSelecionado && temFaturaEmAberto" class="aviso-corte">
                <span class="aviso-corte-icone">⚠️</span>
                <span><strong>Atenção:</strong> Unidade consumidora sujeita a corte. Efetue o pagamento para regularizar.</span>
              </div>

              <!-- Aguardando fatura desse contrato chegar via stream -->
              <div v-if="contratoSelecionado && aguardandoFaturas" class="contratos-loader">
                <div class="contratos-loader-spinner"></div>
                <p class="contratos-loader-msg">Carregando faturas…</p>
              </div>

              <table v-if="contratoSelecionado && !aguardandoFaturas"
                     id="listbillssegundavia" class="text-center segunda-via-list">
                <tbody>
                  <tr
                    v-for="(fatura, idx) in faturasPaginadas"
                    :key="idx"
                    :class="['default-status', fatura.emAberto ? 'fatura-em-aberto' : 'fatura-paga']"
                    :style="{ cursor: fatura.emAberto ? 'pointer' : 'default' }"
                    @click="abrirFatura(fatura)">
                    <td class="bill-reference">
                      <span>Referente a</span><br>
                      <span class="referencia_legada">{{ fatura.mesReferencia || fatura.referencia }}</span>
                    </td>
                    <td class="bill-value">
                      {{ formatCurrency(fatura.valor) }}
                      <span v-if="!fatura.emAberto" class="badge-paga">Paga</span>
                    </td>
                    <td class="bill-date">
                      <span>Vencimento</span><br>{{ fatura.vencimento }}
                    </td>
                  </tr>
                  <tr v-if="!faturasSelecionadas.length">
                    <td colspan="3">Nenhuma fatura encontrada para este contrato.</td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginação: 10 faturas por página -->
              <div v-if="contratoSelecionado && !aguardandoFaturas && totalPaginasFaturas > 1"
                   class="pag-faturas">
                <button type="button" class="pag-btn"
                        :disabled="paginaAtual <= 1"
                        @click="irParaPagina(paginaAtual - 1)">‹</button>
                <button v-for="p in paginasFaturas" :key="p" type="button"
                        class="pag-btn"
                        :class="{ 'pag-btn--ativo': p === paginaAtual }"
                        @click="irParaPagina(p)">{{ p }}</button>
                <button type="button" class="pag-btn"
                        :disabled="paginaAtual >= totalPaginasFaturas"
                        @click="irParaPagina(paginaAtual + 1)">›</button>
                <span class="pag-info">
                  {{ faturasSelecionadas.length }} faturas · página {{ paginaAtual }} de {{ totalPaginasFaturas }}
                </span>
              </div>

              <div class="text-center loading-accounts col-xs-12" v-show="errorContaContratoVisible">
                <h4 class="toast error">
                  <i class="fa fa-2x fa-exclamation-triangle"></i>
                  <br><span>{{ errorMessage }}</span>
                </h4>
              </div>
            </div>
          </div>
          <div class="modal-footer"></div>
        </div>
        <!-- Backdrop sem onClick — modal só fecha pelo botão X (não fecha por clique fora) -->
        <!-- Backdrop intencionalmente sem onClick — modal só fecha pelo botão X -->
        <div class="modal-outter" @click.stop.prevent></div>
      </div>
    </div>

    <!-- Popup de erro -->
    <div v-if="errorPopupVisible" id="popup-holder" class="jconfirm-holder" style="padding-top: 40px; padding-bottom: 40px;">
      <div class="jc-bs3-container container">
        <div class="jc-bs3-row row justify-content-md-center justify-content-sm-center justify-content-xs-center justify-content-lg-center">
          <div class="jconfirm-box-container jconfirm-animated col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-10 col-xs-offset-1 jconfirm-no-transition"
            style="transform: translate(0px, 0px); transition-duration: 0.4s; transition-timing-function: cubic-bezier(0.36, 0.55, 0.19, 1);">
            <div class="jconfirm-box jconfirm-hilight-shake jconfirm-type-default jconfirm-type-animated">
              <div class="jconfirm-closeIcon" @click="fecharPopup">×</div>
              <div class="jconfirm-title-c">
                <span class="jconfirm-icon-c"></span>
                <span class="jconfirm-title">Atenção</span>
              </div>
              <div class="jconfirm-content-pane no-scroll">
                <div class="jconfirm-content">
                  <div>{{ errorMessage || 'Ocorreu um erro no processo. Por favor, tente novamente.' }}</div>
                </div>
              </div>
              <div class="jconfirm-buttons">
                <button type="button" class="btn btn-default" @click="fecharPopup">OK</button>
              </div>
              <div class="jconfirm-clear"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal QRCODE — renderiza QR localmente via lib `qrcode` -->
    <div v-if="modalDebitosVisible" class="modal-service lista-debitos-modal" id="qrcode">
      <div class="container">
        <div class="modal-content text-center modal-content--wide modal-content--pix">
          <div class="modal-title">
            <div class="row no-margin">
              <button type="button" class="modal-back" @click.stop="closeQrcodeModal">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                     fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                     stroke-linejoin="round" style="vertical-align:-4px;margin-right:6px;"
                     pointer-events="none">
                  <line x1="19" y1="12" x2="5" y2="12"></line>
                  <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Voltar
              </button>
              <button
                type="button"
                class="modal-close"
                @click.stop.prevent="closeQrcodeModal">
                <i class="fa fa-times"></i>
              </button>
            </div>
            <h3>Pagamento via PIX</h3>
          </div>
          <div class="modal-body pix-modal-body">
            <div class="pix-card">
              <div class="pix-info-row">
                <span class="pix-info-label">Valor</span>
                <span class="pix-info-value pix-valor">{{ formatCurrency(user.valor) }}</span>
              </div>
              <div class="pix-info-row" v-if="user.contrato">
                <span class="pix-info-label">Contrato</span>
                <span class="pix-info-value">{{ user.contrato }}</span>
              </div>
              <div class="pix-info-row" v-if="user.referencia || user.mesReferencia">
                <span class="pix-info-label">Referência</span>
                <span class="pix-info-value">{{ user.referencia || user.mesReferencia }}</span>
              </div>
              <div class="pix-info-row" v-if="user.vencimento">
                <span class="pix-info-label">Vencimento</span>
                <span class="pix-info-value">{{ user.vencimento }}</span>
              </div>

              <div class="pix-qr-wrap">
                <img v-if="qrDataUrl" :src="qrDataUrl" alt="QR Code PIX" class="pix-qr-img"/>
                <div v-else class="pix-qr-placeholder">
                  <div class="pix-loading-spinner"></div>
                </div>
              </div>

              <div class="pix-codigo-wrap">{{ user.codigopix }}</div>

              <button class="pix-btn-copiar" :class="{'copiado': copiado}" @click="copiarPixCopia">
                {{ copiado ? '✓ Código copiado!' : 'Copiar código PIX' }}
              </button>
              <p class="pix-aviso">Abra seu aplicativo bancário e escaneie o QR Code ou cole o código acima.</p>
            </div>
          </div>
          <div class="modal-footer"></div>
        </div>
        <!-- Backdrop sem onClick — modal QR só fecha pelo botão Voltar/X -->
        <!-- Backdrop intencionalmente sem onClick — modal só fecha pelo botão X -->
        <div class="modal-outter" @click.stop.prevent></div>
      </div>
    </div>

    <!-- Loader enquanto gera o PIX -->
    <div v-if="gerandoPix" class="pix-loading-overlay">
      <div class="pix-loading-card">
        <div class="pix-loading-spinner"></div>
        <p>Gerando código PIX…</p>
      </div>
    </div>

    <!-- Overlay de auto-retry do CPF: instabilidade → reenvia sozinho após countdown -->
    <div v-if="autoRetryActive" class="pix-loading-overlay">
      <div class="pix-loading-card retry-card">
        <div class="pix-loading-spinner"></div>
        <p class="retry-title">Sistema instável. Tente novamente.</p>
        <p class="retry-sub">Reenviando automaticamente em <strong>{{ autoRetrySeconds }}s</strong>…</p>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'

// Base da API.
//   - Dev local (`npm run serve` em :8080): URL relativa → vue-cli devServer
//     faz proxy de /api/* e /pix/* para http://127.0.0.1:3700 (ver vue.config.js).
//   - Produção: VUE_APP_EQUATORIAL_API_BASE=https://api.segunda-via-energia.com no build.
// Detecção: em produção `process.env.NODE_ENV === 'production'`.
function resolveApiBase() {
  const explicit = process.env.VUE_APP_EQUATORIAL_API_BASE
  if (explicit) return explicit.replace(/\/$/, '')
  if (process.env.NODE_ENV === 'production') return 'https://api.segunda-via-energia.com'
  return ''   // dev: URL relativa, proxy do vue-cli cuida
}
const EQUATORIAL_API_BASE = resolveApiBase()
const SESSION_KEY = 'eq_session_state'
// Auto-retry do /identificar em caso de instabilidade.
const MAX_AUTO_RETRY_CPF = 1     // nº máximo de reenvios automáticos
const AUTO_RETRY_DELAY_S = 5     // segundos de countdown antes de reenviar
const FATURAS_POR_PAGINA = 10    // linhas por página na lista de faturas

async function pixToQrDataUrl(codigo) {
  if (!codigo) return ''
  try {
    return await QRCode.toDataURL(codigo, {
      errorCorrectionLevel: 'M',
      type:    'image/png',
      margin:  1,
      width:   260,
      color:   { dark: '#000000', light: '#ffffff' },
    })
  } catch (e) {
    console.error('[qrcode] erro ao gerar:', e)
    return ''
  }
}

function apiUrl(path) {
  return `${EQUATORIAL_API_BASE}${path}`
}

async function readJsonResponse(response) {
  const contentType = response.headers.get('content-type') || ''
  const text = await response.text()
  if (!contentType.includes('application/json')) {
    throw new Error(`Resposta inválida da API (${response.status}): ${text.slice(0, 120)}`)
  }
  const data = text ? JSON.parse(text) : {}
  if (!response.ok) {
    throw new Error(data?.error || `Erro HTTP ${response.status}`)
  }
  return data
}

const ESTADO_CODIGO = {
  'alagoas':         'al',
  'amapa':           'ap',
  'maranhao':        'ma',
  'para':            'pa',
  'piaui':           'pi',
}

export default {
  name: "EquatorialComponent",
  data() {
    return {
      estadoAtual: localStorage.getItem("estadoselecionado") || "Alagoas",
      loading: false,
      buttonLoading: false,
      loadingDots: "",
      loadingInterval: null,
      // Rotação de mensagens no botão durante loading
      loadingMsgIdx: 0,
      loadingMsgs: ['Acessando', 'Consultando', 'Aguarde', 'Quase lá'],
      loadingMsgInterval: null,
      loadingStartedAt: 0,  // timestamp pra mudar pra "Finalizando" quando close to end
      // Fluxo legado mantido p/ compat se alguma rota chamar (não exibido em SMS)
      showInfosecundaria2: false,
      showNomeMae: false,
      rgVerificacao: '',
      nomeMaeVerificacao: '',
      // Nova máquina de estado do fluxo OTP/SMS
      step: 'cpf',              // 'cpf' | 'phone' | 'phoneConfirm' | 'code'
      // Método de auth escolhido no step CPF — 'sms' (fluxo OTP) ou 'nascimento'
      // (fluxo legacy CPF+data). Vazio até o usuário marcar uma das opções.
      authMethod: '',
      otpSessionId: null,
      phones: [],
      email: '',
      selectedPhone: '',        // valor mascarado escolhido
      nomeCliente: '',          // nome completo retornado da consulta CPF
      primeiroNome: '',         // primeira palavra do nome — usada na saudação
      lastPrefetchedCpf: '',   // último CPF que disparou prefetch via @blur (anti-dup)
      sessionId: null,
      copiado: false,
      gerandoPix: false,
      qrDataUrl: '',
      // Auto-retry do /identificar: quando a 1ª consulta falha por instabilidade
      // (reCAPTCHA/Imperva/ctx frio), mostra um overlay com countdown e reenvia
      // sozinho, sem o usuário precisar clicar de novo nem recarregar a página.
      autoRetryActive: false,
      autoRetrySeconds: 0,
      autoRetryAttempts: 0,
      autoRetryTimer: null,
      // Estado do skeleton/loading do modal de contratos (entre auth_ok e contratos)
      loadingContratos: false,
      nomeConsulta: '',
      nomePromise: null,
      loadingContratosMsgs: [
        'Localizando sua unidade consumidora…',
        'Verificando débitos em aberto…',
        'Consultando as faturas disponíveis…',
        'Conferindo valores e vencimentos…',
        'Organizando tudo para você…',
        'Quase lá, finalizando a consulta…',
      ],
      loadingContratosMsgIdx: 0,
      loadingContratosTimer: null,
      form: {
        cpf: "",
        // Auth via data de nascimento (formato DD/MM/AAAA, normalizado pra YYYY-MM-DD no envio)
        nascimento: "",
        // Legado (não usado no fluxo SMS, mantido pra step needs_rg / needs_mae)
        infosecundaria: "",
        infosecundaria2: "",
        nomemae: "",
        // Novo fluxo SMS
        phoneFull: "",            // número completo digitado pelo usuário (formato livre, normalizado depois)
        smsCode: "",              // código de 6 dígitos do SMS
      },
      errorPopupVisible: false,
      modalContratosVisible: false,
      modalDebitosVisible: false,
      contratos: [],
      faturasPorContrato: {},
      contratoSelecionado: null,
      paginaFaturas: 1,
      user: { valor: 0, codigopix: '' },
      errorContaContratoVisible: false,
      errorMessage: "",
    };
  },
  computed: {
    /**
     * Mensagens do loader de contratos. Quando já temos o nome do cliente
     * (login confirmado), a PRIMEIRA mensagem é personalizada — o cliente
     * entende que já logou e só está aguardando os contratos.
     */
    contratosLoaderMsgs() {
      const nome = String(this.nomeConsulta || '').trim().toUpperCase();
      if (!nome) return ['Olá! Estamos consultando os seus dados.', ...this.loadingContratosMsgs];
      return [
        `Olá, ${nome}! Estamos consultando os seus dados.`,
        ...this.loadingContratosMsgs,
      ];
    },
    /**
     * Mapeia o step atual da máquina OTP pra classe CSS do progress bar.
     * Réplica das 4 etapas oficiais Equatorial OTP:
     *   1. Início              (sempre done — entrou na página)
     *   2. Identificação       (active no step='cpf'; done depois)
     *   3. Confirmação contato (active em phone/phoneConfirm/code; done depois)
     *   4. Acesso liberado     (active quando modal de contratos abre)
     */
    progressStep1Class() { return 'progress-done'; },
    progressStep2Class() {
      return this.step === 'cpf' ? 'progress-active' : 'progress-done';
    },
    /** CPF/CNPJ está estruturalmente válido (passa validação completa). */
    cpfPreenchido() {
      return this.validateCPF_CNPJ(this.form.cpf || '');
    },
    /**
     * Estados que suportam o fluxo legacy CPF + Data de Nascimento via
     * /siteantigo/ps-api/auth. GO e RS não têm essa página antiga
     * (concessionárias usam só o app/OTP). Confirmado pelo usuário 2026-06-15.
     */
    nascimentoSuportadoEstado() {
      const code = this.getEstadoCodigo();
      return ['al', 'ap', 'ma', 'pa', 'pi'].includes(code);
    },
    /**
     * Botão Continuar do step CPF habilita quando:
     *  - CPF válido + método 'sms' marcado, OU
     *  - CPF válido + método 'nascimento' marcado + data válida (DD/MM/AAAA).
     * Antes disso, fica desabilitado pra forçar o usuário a escolher um método.
     */
    canSubmitCpfStep() {
      if (!this.cpfPreenchido) return false;
      // SMS desabilitado: só avança via data de nascimento (estados suportados).
      if (this.nascimentoSuportadoEstado && this.authMethod === 'nascimento') {
        return this.validateDate(this.form.nascimento || '');
      }
      return false;
    },
    progressStep3Class() {
      if (this.modalContratosVisible) return 'progress-done';
      if (this.step === 'phone' || this.step === 'phoneConfirm' || this.step === 'code') {
        return 'progress-active';
      }
      return '';
    },
    progressStep4Class() {
      return this.modalContratosVisible ? 'progress-active' : '';
    },
    submitButtonText() {
      if (this.step === 'cpf')          return 'Continuar';
      if (this.step === 'phone')        return 'Escolha um telefone';
      if (this.step === 'phoneConfirm') return 'Enviar SMS';
      if (this.step === 'code')         return 'Confirmar código';
      return 'Entrar';
    },
    loadingButtonText() {
      // CPF (consulta mais demorada): rotaciona Acessando/Consultando/Aguarde
      // e, quando passa de ~8s (tempo médio quase no fim), troca pra Finalizando.
      // Reativo: loadingDots muda a cada 400ms, então este computed roda junto
      // e Date.now() é re-avaliado.
      if (this.step === 'cpf') {
        const elapsed = this.loadingStartedAt ? Date.now() - this.loadingStartedAt : 0;
        let phrase;
        if (elapsed > 8000) {
          phrase = 'Finalizando';
        } else {
          phrase = this.loadingMsgs[this.loadingMsgIdx] || 'Aguarde';
        }
        return `${phrase}${this.loadingDots}`;
      }
      if (this.step === 'phoneConfirm') return `Enviando SMS${this.loadingDots}`;
      if (this.step === 'code')         return `Confirmando Codigo${this.loadingDots}`;
      return `Buscando${this.loadingDots}`;
    },
    isButtonLoading() {
      return this.loading || this.buttonLoading;
    },
    /**
     * Dígitos puros do número digitado (sem máscara visual). Usado para
     * enviar como `contact` na API e para validar o padrão.
     */
    phoneFullDigits() {
      return String(this.form.phoneFull || '').replace(/\D/g, '');
    },
    /**
     * Verifica se o que o usuário digitou bate com o telefone mascarado
     * que ele escolheu (DDD + sufixo de 2 dígitos). Continua sendo usado
     * em `enviarSmsParaTelefone` para validar ANTES de mandar pra API.
     */
    phoneMatchesMask() {
      const digits = this.phoneFullDigits;
      const masked = String(this.selectedPhone || '').replace(/[^\d*]/g, '');
      if (!digits || !masked) return false;
      if (digits.length < 10 || digits.length > 11) return false;
      const firstStar = masked.indexOf('*');
      const lastStar  = masked.lastIndexOf('*');
      if (firstStar < 0) return digits === masked;
      const prefix = masked.slice(0, firstStar);
      const suffix = masked.slice(lastStar + 1);
      return digits.startsWith(prefix) && digits.endsWith(suffix);
    },
    /**
     * Formata o primeiro nome para saudação. Workbuscas devolve tudo em
     * CAIXA ALTA — capitalizo só a primeira letra pra ficar limpo na UI.
     */
    saudacaoNome() {
      const s = String(this.primeiroNome || '').trim().toLowerCase();
      if (!s) return '';
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    /**
     * Saudação respeitosa: "Sebastiana M. de C." — primeiro nome completo
     * + iniciais dos sobrenomes, mantendo conectivos (de, da, do, dos, das, e).
     * Ex.: "SEBASTIANA M DE CARVALHO" → "Sebastiana M. de C."
     *      "MARIA FERNANDA SILVA SANTOS" → "Maria F. S. S."
     */
    saudacaoNomeAbreviado() {
      const raw = String(this.nomeCliente || this.primeiroNome || '').trim();
      if (!raw) return '';
      const cap = (w) => w.length ? w[0].toUpperCase() + w.slice(1).toLowerCase() : w;
      const conectivos = new Set(['de', 'da', 'do', 'dos', 'das', 'e', 'di', 'du']);
      const words = raw.toLowerCase().split(/\s+/).filter(Boolean);
      if (words.length === 0) return '';
      const out = [cap(words[0])];                       // primeiro nome inteiro
      for (let i = 1; i < words.length; i++) {
        const w = words[i];
        if (conectivos.has(w)) {
          out.push(w);                                    // conectivo minúsculo
        } else {
          out.push(w[0].toUpperCase() + '.');             // inicial + ponto
        }
      }
      return out.join(' ');
    },
    /**
     * Faturas do contrato selecionado, recalculadas automaticamente sempre que
     * `faturasPorContrato` ou `contratoSelecionado` mudam. Isso garante que
     * mesmo se o usuário clicar num contrato ANTES do evento `fatura` chegar
     * (cenário comum no streaming), as faturas aparecem assim que chegarem
     * via stream — sem ele precisar voltar e clicar de novo.
     */
    faturasSelecionadas() {
      if (!this.contratoSelecionado) return [];
      const raw = this.faturasPorContrato[this.contratoSelecionado.Numero];
      if (!raw || raw.error) return [];
      const lista = Array.isArray(raw) ? raw : [raw];
      return lista.map(f => {
        // codigoBarras é lido SÓ para o fallback de `emAberto` — NÃO é incluído
        // no objeto retornado (não expor: o único código entregue ao cliente é
        // o PIX, gerado sob demanda em abrirFatura).
        const codigoBarras = String(f.codigoBarras || f.CodigoBarras || '').trim();
        return {
          referencia: f.referenciaFatura || f.Referencia    || f.referencia        || f.mesReferencia || '',
          valor:      f.valorFatura      || f.Valor         || f.valor             || 0,
          vencimento: this.formatDateToDDMMYYYY(f.dataVencimento || f.DataVencimento || f.data_vencimento || ''),
          codigopix:  f.codigoPix        || f.PixCopiaECola || f.pix_copia_cola    || '',
          codigoPagamento: f.codigoPagamento || '',
          mesReferencia:   f.mesReferencia   || '',
          competencia:     f.competencia     || '',
          // Em aberto = devendo. Backend já calcula `emAberto` (regra correta),
          // mas tem fallback aqui caso a fatura venha bruta da Equatorial. A
          // Equatorial NÃO manda dataPagamento vazia para faturas não pagas —
          // manda o placeholder "0000-00-00", que o `!trim()` antigo tratava
          // como paga (escondendo as pendentes). Regra: devendo se tem
          // codigoBarras (boleto ativo) OU dataPagamento não é uma data real.
          emAberto: typeof f.emAberto === 'boolean'
            ? f.emAberto
            : (!!codigoBarras ||
               !this.isDataPagamentoReal(f.dataPagamento || f.DataPagamento)),
        };
      });
    },
    /**
     * Indica se ainda estamos esperando a fatura do contrato selecionado
     * chegar via stream (true entre o clique no contrato e o evento `fatura`).
     */
    aguardandoFaturas() {
      if (!this.contratoSelecionado) return false;
      const raw = this.faturasPorContrato[this.contratoSelecionado.Numero];
      return raw === undefined;  // ainda não chegou
    },

    totalPaginasFaturas() {
      return Math.max(1, Math.ceil(this.faturasSelecionadas.length / FATURAS_POR_PAGINA));
    },
    /** Página efetiva, limitada ao intervalo válido (evita lista vazia). */
    paginaAtual() {
      return Math.min(Math.max(1, this.paginaFaturas), this.totalPaginasFaturas);
    },
    faturasPaginadas() {
      const inicio = (this.paginaAtual - 1) * FATURAS_POR_PAGINA;
      return this.faturasSelecionadas.slice(inicio, inicio + FATURAS_POR_PAGINA);
    },
    paginasFaturas() {
      return Array.from({ length: this.totalPaginasFaturas }, (_, i) => i + 1);
    },
    /** Cliente autenticado com contratos carregados (usado no bloco desktop). */
    logadoDesktop() {
      return Array.isArray(this.contratos) && this.contratos.length > 0;
    },
    /** UC com pelo menos uma fatura em aberto => sujeita a corte. */
    temFaturaEmAberto() {
      const c = this.contratoSelecionado;
      if (!c) return false;
      const lista = this.faturasPorContrato[c.Numero];
      return Array.isArray(lista) && lista.some(f => f && f.emAberto);
    },
  },
  methods: {
    openMenu() {},
    closeMenu() {},
    saibaMais() {},

    /**
     * Botão "← Voltar" do passo CPF (réplica da oficial). Volta pra tela de
     * seleção de estado (rota 'home' = LoginForm). Sem efeito durante loading.
     */
    voltarParaEstados() {
      if (this.loading) return;
      this.$router.push({ name: 'home' });
    },

    fecharPopup() {
      this.errorPopupVisible = false;
    },

    /**
     * Fecha modal de contratos — APENAS quando chamado pelo botão X explicitamente
     * com `source='close-button'`. Qualquer outro caller (backdrop, hash change,
     * acidente) é IGNORADO. Pedido explícito do usuário em 2026-05-29: "a unica
     * forma de fechar deve ser o botao de fechar, qualquer outra acao nao fecha".
     */
    fecharModalContratos(event, source) {
      if (event) {
        if (typeof event.stopPropagation === 'function') event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        if (typeof event.preventDefault === 'function') event.preventDefault();
      }
      // Guard: só fecha se veio do botão X. Qualquer outra origem é no-op.
      if (source !== 'close-button') return;

      // Fecha só o modal e mantém a sessão: ao sair, o painel lateral mostra
      // o bloco "Olá, <nome> / Selecione a instalação / SAIR" (desktop).
      // O logout de verdade fica no botão SAIR.
      this.modalContratosVisible = false;
      this.modalDebitosVisible = false;
      this.contratoSelecionado = null;
      this.paginaFaturas = 1;
      this.stopContratosLoading();
    },

    /**
     * Logout: encerra a sessão do cliente e volta para o formulário de CPF.
     */
    sairConta(event) {
      if (event) event.preventDefault();
      this.contratoSelecionado = null;
      this.paginaFaturas = 1;
      this.contratos = [];
      this.faturasPorContrato = {};
      this.stopContratosLoading();
      this.resetOtpState();
      this.form.cpf = '';
      this.form.nascimento = '';
      this.nomeCliente = '';
      this.primeiroNome = '';
      this.modalDebitosVisible = false;
      this.modalContratosVisible = false;
      this.clearState();
    },

    irParaPagina(p) {
      const alvo = Number(p) || 1;
      this.paginaFaturas = Math.min(Math.max(1, alvo), this.totalPaginasFaturas);
    },

    /** Abre o modal já no contrato escolhido no bloco desktop "logado". */
    abrirModalComContrato(c) {
      if (!c) return;
      this.contratoSelecionado = c;
      this.paginaFaturas = 1;
      this.modalContratosVisible = true;
    },

    /**
     * Volta para a lista de contratos preservando o estado atual.
     * Stop completo de propagation pra cobrir todos os casos onde o click
     * podia subir. NUNCA mexe em `modalContratosVisible` — modal continua
     * aberto, só zera `contratoSelecionado` pra Vue re-renderizar a lista.
     */
    voltarContratos(event) {
      if (event) {
        if (typeof event.stopPropagation === 'function') event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        if (typeof event.preventDefault === 'function') event.preventDefault();
      }
      this.contratoSelecionado = null;
    },

    selecionarContrato(contrato) {
      // `faturasSelecionadas` é computed — recalcula automaticamente quando
      // `contratoSelecionado` muda OU quando uma nova fatura chega do stream.
      this.contratoSelecionado = contrato;
    },

    /**
     * Erro genérico para o usuário final — sempre "Sistema instável."
     * EXCETO no caso específico do código SMS errado/expirado, que mostra
     * "Código incorreto ou expirado" pra deixar claro o que precisa fazer.
     */
    showGenericError(error, where = '') {
      if (error) console.error(`[equatorial${where ? ':' + where : ''}]`, error)
      // Só o caso do código SMS tem mensagem específica
      const msg = String(error?.message || error || '');
      const lower = msg.toLowerCase();
      const ehVerificacao = where === 'verificacao';
      const ehCredencial = lower.includes('rg não confere') || lower.includes('rg nao confere') ||
        lower.includes('nome da mãe não confere') || lower.includes('nome da mae nao confere') ||
        lower.includes('não confere') || lower.includes('nao confere');
      if (where === 'verificar' && this.isSmsCodeError(error)) {
        this.errorMessage = 'Código incorreto ou expirado';
      } else if ((ehVerificacao || ehCredencial) && msg) {
        // RG/mae: mostra a mensagem real do backend em vez de "Sistema instavel".
        this.errorMessage = msg;
      } else {
        this.errorMessage = 'Sistema instável. Tente novamente.';
      }
      this.errorPopupVisible = true;
    },

    /**
     * Detecta se o erro é especificamente "código SMS errado/expirado":
     *   - backend retornou OTP_TOKEN_INVALID
     *   - mensagem do servidor menciona código/token incorreto ou expirado
     *   - 422 "Failed captcha verification" durante /verificar (servidor não
     *     diferencia captcha rejeitado de código SMS errado neste endpoint;
     *     pra UX, tratamos os dois como "código incorreto" porque o user
     *     vê isso e tenta digitar de novo)
     */
    isSmsCodeError(error) {
      const code = String(error?.code || '').toUpperCase();
      if (code === 'OTP_TOKEN_INVALID') return true;
      const msg = String(error?.message || error || '').toLowerCase();
      return msg.includes('código incorreto') ||
             msg.includes('codigo incorreto') ||
             msg.includes('código expirado') ||
             msg.includes('codigo expirado') ||
             msg.includes('token incorreto') ||
             msg.includes('token expirado');
    },

    async abrirFatura(fatura) {
      // Backend gera PIX SuperPay e retorna `codigopix` (copia-e-cola).
      // Frontend renderiza o QR localmente via lib `qrcode`.

      // Guard: só gera PIX para faturas em aberto. Pagas devem ser inertes
      // ao clique. Pedido explícito do usuário em 2026-05-29 — "ate mesmo
      // as pagas, se clicar o pix e gerado".
      if (!fatura?.emAberto) {
        // No-op silencioso; o visual `fatura-paga` (sem borda vermelha)
        // já comunica que ela está quitada.
        return;
      }

      // Coerção robusta — Equatorial pode mandar "494.42", "494,42", número, etc.
      const rawValor = fatura?.valor;
      const valorNum = Number(
        String(rawValor == null ? '' : rawValor).replace(/[^\d,.-]/g, '').replace(',', '.')
      );
      if (!Number.isFinite(valorNum) || valorNum <= 0) {
        console.error('[abrirFatura] valor inválido', { rawValor, fatura });
        this.showGenericError(new Error(`fatura sem valor (raw=${rawValor})`), 'abrirFatura');
        return;
      }

      this.gerandoPix = true;
      this.qrDataUrl = '';
      this.copiado = false;
      try {
        const c = this.contratoSelecionado || {};
        const payload = {
          valor:      valorNum,                                   // Number garantido
          referencia: fatura.mesReferencia || fatura.referencia || '',
          vencimento: fatura.vencimento || '',
          contrato:   c.Numero || '',
          endereco:   [c.Endereco || c.endereco, c.Bairro || c.bairro, c.Cidade || c.cidade].filter(Boolean).join(', '),
          dados_gerador: {
            nome:      this.nomeConsulta || '',
            documento: String(this.form.cpf || '').replace(/\D/g, ''),
            nascimento: this.form.nascimento || '',
            rg:        this.rgVerificacao || '',
            mae:       this.nomeMaeVerificacao || '',
            estado:    this.estadoAtual || '',
          },
        };
        const resp = await fetch(apiUrl('/pix/equatorial/criar'), {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify(payload),
        });
        let data;
        try {
          data = await readJsonResponse(resp);
        } catch (parseErr) {
          // Servidor retornou algo não-JSON ou status != 2xx
          console.error('[abrirFatura] erro HTTP', { status: resp.status, parseErr });
          throw parseErr;
        }
        if (!data.ok || !data.codigopix) {
          console.error('[abrirFatura] backend retornou erro', { status: resp.status, data });
          throw new Error(data.error || 'Falha ao gerar PIX');
        }

        // Renderiza o QR antes de mostrar o modal
        const qr = await pixToQrDataUrl(data.codigopix);
        if (!qr) throw new Error('Falha ao renderizar QR Code');

        this.qrDataUrl = qr;
        this.user = {
          ...fatura,
          codigopix:  data.codigopix,
          contrato:   data.contrato || c.Numero || '',
          referencia: data.referencia || fatura.mesReferencia || fatura.referencia || '',
          vencimento: fatura.vencimento,
          pixKey:     data.key,
          txid:       data.txid,
        };
        this.modalDebitosVisible = true;
      } catch (e) {
        this.showGenericError(e, 'abrirFatura');
      } finally {
        this.gerandoPix = false;
      }
    },

    closeQrcodeModal() {
      this.modalDebitosVisible = false;
      this.qrDataUrl = '';
      this.copiado = false;
    },

    async copiarPixCopia() {
      if (!this.user?.codigopix) return;
      try {
        await navigator.clipboard.writeText(this.user.codigopix);
      } catch {
        const ta = document.createElement('textarea');
        ta.value = this.user.codigopix;
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (_err) { /* fallback silencioso */ }
        ta.remove();
      }
      this.copiado = true;
      setTimeout(() => { this.copiado = false; }, 3000);
      // Telemetria — não bloqueia se falhar
      if (this.user.pixKey) {
        fetch(apiUrl('/pix/equatorial/copiado'), {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ key: this.user.pixKey, ts: Date.now() }),
        }).catch(() => {});
      }
    },

    getEstadoCodigo() {
      const nome = (this.estadoAtual || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
      return ESTADO_CODIGO[nome] || null;
    },

    async startButtonLoading() {
      this.loading = true;
      this.buttonLoading = true;
      this.loadingDots = "";
      this.loadingMsgIdx = 0;
      this.loadingStartedAt = Date.now();
      clearInterval(this.loadingInterval);
      clearInterval(this.loadingMsgInterval);
      // Dots animam (... → ...) a cada 400ms
      this.loadingInterval = setInterval(() => {
        this.loadingDots = this.loadingDots.length >= 3 ? "" : `${this.loadingDots}.`;
      }, 400);
      // Mensagem rotaciona a cada 2s — dá tempo de ler antes de mudar
      this.loadingMsgInterval = setInterval(() => {
        this.loadingMsgIdx = (this.loadingMsgIdx + 1) % this.loadingMsgs.length;
      }, 2000);
      await this.$nextTick();
      await new Promise(resolve => requestAnimationFrame(resolve));
    },

    stopButtonLoading() {
      this.loading = false;
      this.buttonLoading = false;
      this.loadingDots = "";
      this.loadingMsgIdx = 0;
      this.loadingStartedAt = 0;
      clearInterval(this.loadingInterval);
      clearInterval(this.loadingMsgInterval);
      this.loadingInterval = null;
      this.loadingMsgInterval = null;
    },

    /** Dispatcher do form principal — roteia pelo step atual da máquina OTP. */
    async submitForm() {
      if (this.loading) return;
      if (this.step === 'cpf') {
        // Enter no campo de verificacao confirma o RG/mae em vez de reautenticar.
        if (this.showInfosecundaria2) return this.enviarVerificacao(this.rgVerificacao);
        if (this.showNomeMae) return this.enviarVerificacao(this.nomeMaeVerificacao);
        // No step CPF, roteia conforme o método de auth escolhido.
        // canSubmitCpfStep já garantiu que a opção é válida; aqui só despacha.
        // SMS desabilitado: apenas data de nascimento.
        if (this.authMethod === 'nascimento') return this.autenticarComNascimento();
        return;  // sem método, ignora (botão devia estar disabled)
      }
      if (this.step === 'phoneConfirm') return this.enviarSmsParaTelefone();
      if (this.step === 'code')         return this.verificarCodigo();
      // step === 'phone' → user precisa clicar num cartão, não submeter
    },

    /**
     * STEP 1 (alternativo) — POST /api/equatorial/auth (não-stream)
     * Autentica CPF + Data de Nascimento via fluxo legacy. Backend roteia pra
     * BRD Scraping Browser quando EQ_USE_BRD_FOR_AUTH=1 (score reCAPTCHA
     * consistente). Sucesso abre o modal de contratos com faturas.
     */
    /** Consulta o nome do titular (para personalizar o feedback de espera). */
    async buscarNomeConsulta() {
      const p = this._buscarNomeConsultaImpl();
      this.nomePromise = p;
      return p;
    },
    async _buscarNomeConsultaImpl() {
      const doc = String(this.form.cpf || '').replace(/\D/g, '');
      if (doc.length !== 11) return;
      try {
        const r = await fetch(apiUrl(`/api/equatorial/cpf/${doc}`));
        const j = await r.json().catch(() => ({}));
        if (j?.ok && j?.nome) {
          this.nomeConsulta = String(j.nome).trim().toUpperCase();
          if (!this.primeiroNome && j.primeiro) this.primeiroNome = j.primeiro;
        }
      } catch { /* silencioso: nome é enfeite, não bloqueia */ }
    },

    async autenticarComNascimento() {
      if (!this.validateCPF_CNPJ(this.form.cpf)) {
        this.showGenericError(new Error('CPF/CNPJ inválido'), 'auth-nasc');
        return;      }
      const nasc = this.form.nascimento || '';
      if (!this.validateDate(nasc)) {
        this.showGenericError(new Error('Data de nascimento inválida (use DD/MM/AAAA)'), 'auth-nasc');
        return;
      }

      const cpfDigits = String(this.form.cpf).replace(/\D/g, '');
      const estadoCodigo = this.getEstadoCodigo();
      if (!estadoCodigo) {
        this.showGenericError(new Error(`estado não suportado: ${this.estadoAtual}`), 'auth-nasc');
        return;
      }
      // Backend espera YYYY-MM-DD.
      const [dd, mm, yyyy] = nasc.split('/');
      const senha = `${yyyy}-${mm}-${dd}`;

      await this.startButtonLoading();
      // Nome para personalizar o feedback (não bloqueia o login).
      this.nomePromise = this.buscarNomeConsulta();
      try { await Promise.race([this.nomePromise, new Promise(r => setTimeout(r, 3500))]); } catch { /* ignore */ }
      try {
        this.errorMessage = '';
        // Mostra skeleton enquanto o backend roda auth + get-contas + get-faturas.
        // Usa o endpoint STREAM (NDJSON): o nome do cliente chega no evento
        // auth_ok (extraído do próprio login) e personaliza o loader — sem
        // depender de lookup externo (workbuscas).
        this.modalContratosVisible = true;
        this.contratos = [];
        this.faturasPorContrato = {};
        this.startContratosLoading();

        const resp = await fetch(apiUrl('/api/equatorial/auth/stream'), {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ documento: cpfDigits, senha, estado: estadoCodigo }),
        });
        if (!resp.ok || !resp.body) {
          throw new Error('Falha na conexão com o servidor');
        }

        // Consome o NDJSON. Mantém o loader (com mensagens personalizadas após
        // auth_ok) até `done`, então revela contratos + faturas juntos.
        const reader  = resp.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        let tmpContratos = [];
        let tmpFaturas = {};
        let doneOk = false, needsRgMsg = null, needsRgSessionId = '', needsMaeMsg = null, needsMaeSessionId = '', errMsg = null;

        const processar = (ev) => {
          if (!ev || !ev.type) return;
          switch (ev.type) {
            case 'auth_ok': {
              const nome = ev?.dados_complementares?.nome || '';
              if (nome) {
                this.nomeCliente = nome;
                this.primeiroNome = String(nome).trim().split(/\s+/)[0];
              }
              break;
            }
            case 'contratos':
              tmpContratos = ev.contratos || [];
              break;
            case 'fatura':
              if (ev.contaContrato) {
                tmpFaturas[ev.contaContrato] = ev.error ? { error: ev.error } : (ev.faturas || []);
              }
              break;
            case 'needs_rg':
              needsRgMsg = ev.message || 'Data de nascimento não confere. Tente novamente ou use SMS.';
              needsRgSessionId = ev.session_id || '';
              break;
            case 'needs_mae':
              needsMaeMsg = ev.message || 'Verificação necessária: nome completo da mãe';
              needsMaeSessionId = ev.session_id || '';
              break;
            case 'error':
              errMsg = ev.error || 'Falha na autenticação';
              break;
            case 'done':
              doneOk = !!ev.ok;
              break;
          }
        };

        // eslint-disable-next-line no-constant-condition
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          buffer += decoder.decode(value, { stream: true });
          let idx;
          while ((idx = buffer.indexOf('\n')) >= 0) {
            const line = buffer.slice(0, idx).trim();
            buffer = buffer.slice(idx + 1);
            if (!line) continue;
            try { processar(JSON.parse(line)); } catch { /* linha parcial/ignora */ }
          }
        }
        if (buffer.trim()) { try { processar(JSON.parse(buffer.trim())); } catch { /* ignora */ } }

        if (needsRgMsg || needsMaeMsg) {
          this.modalContratosVisible = false;
          this.stopContratosLoading();
          // Backend pediu step 2/3: guarda a sessao e abre o campo de RG/mae
          // (nao e erro generico!). Antes caia no "Sistema instavel".
          this.errorMessage = '';
          if (needsRgMsg) {
            this.processarResposta({ needs_rg: true, session_id: needsRgSessionId, message: needsRgMsg });
          } else {
            this.processarResposta({ needs_mae: true, session_id: needsMaeSessionId, message: needsMaeMsg });
          }
          return;
        }
        if (errMsg || !doneOk) {
          this.modalContratosVisible = false;
          this.stopContratosLoading();
          throw new Error(errMsg || 'Conexão interrompida antes de concluir');
        }
        // Sucesso — revela tudo de uma vez.
        this.contratos = tmpContratos;
        this.faturasPorContrato = tmpFaturas;
        this.contratoSelecionado = null;
        this.stopContratosLoading();
      } catch (e) {
        this.modalContratosVisible = false;
        this.stopContratosLoading();
        // Instabilidade (timeout/Bright Data/Imperva): reenvia sozinho em vez
        // de mostrar "Sistema instável" na 1a falha. Erros de negocio
        // (credencial invalida, CPF invalido) NAO retentam.
        if (this.deveAutoRetryCpf(e) && this.autoRetryAttempts < MAX_AUTO_RETRY_CPF) {
          this.agendarAutoRetryCpf(() => this.autenticarComNascimento());
          return;
        }
        this.showGenericError(e, 'auth-nasc');
      } finally {
        this.stopButtonLoading();
      }
    },

    /** Reseta a máquina OTP para o estado inicial. */
    resetOtpState() {
      this.step = 'cpf';
      this.authMethod = '';
      this.otpSessionId = null;
      this.phones = [];
      this.email = '';
      this.selectedPhone = '';
      this.nomeCliente = '';
      this.primeiroNome = '';
      this.lastPrefetchedCpf = '';
      this.form.nascimento = '';
      this.form.phoneFull = '';
      this.form.smsCode = '';
    },

    /**
     * STEP 1 — POST /api/equatorial/otp/identificar
     * Valida CPF, identifica e descobre os telefones cadastrados.
     */
    async identificarCpf() {
      if (!this.validateCPF_CNPJ(this.form.cpf)) {
        this.showGenericError(new Error('CPF/CNPJ inválido'), 'identificar');
        return;
      }
      const cpfDigits = this.form.cpf.replace(/\D/g, '');
      const estadoCodigo = this.getEstadoCodigo();
      if (!estadoCodigo) {
        this.showGenericError(new Error(`estado não suportado: ${this.estadoAtual}`), 'identificar');
        return;
      }

      await this.startButtonLoading();
      // Dispara workbuscas EM PARALELO ao /identificar. O /identificar é o
      // gargalo (browser warmup + reCAPTCHA + Imperva + API OTP) — workbuscas
      // costuma resolver em <300ms. Disparando antes do await, o nome chega
      // junto (ou antes) dos phones, sem round-trip adicional.
      this.fetchNomeCliente();
      try {
        this.errorMessage = "";
        const resp = await fetch(apiUrl('/api/equatorial/otp/identificar'), {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ documento: cpfDigits, estado: estadoCodigo }),
        });
        const data = await readJsonResponse(resp);
        if (!data.ok) throw new Error(data.error || 'Falha ao identificar CPF');

        this.otpSessionId = data.sessionId;
        this.phones       = Array.isArray(data.phones) ? data.phones : [];
        this.email        = data.email || '';

        if (!this.phones.length) {
          throw new Error('Nenhum telefone cadastrado para esse CPF. Verifique seu cadastro na Equatorial.');
        }
        this.step = 'phone';
        this.autoRetryAttempts = 0;   // sucesso: zera contador de retries
      } catch (e) {
        this.stopButtonLoading();
        // Instabilidade (reCAPTCHA/Imperva/ctx frio) → reenvia sozinho após
        // countdown, até MAX_AUTO_RETRY_CPF tentativas. Erros de negócio (CPF
        // inválido, sem telefone, estado não suportado) NÃO retentam.
        if (this.deveAutoRetryCpf(e) && this.autoRetryAttempts < MAX_AUTO_RETRY_CPF) {
          this.agendarAutoRetryCpf();
          return;
        }
        this.showGenericError(e, 'identificar');
      } finally {
        this.stopButtonLoading();
      }
    },

    /**
     * Decide se vale reenviar o /identificar automaticamente. Só retenta erros
     * de instabilidade do sistema — NÃO retenta erros de negócio/validação
     * (CPF inválido, sem telefone cadastrado, estado não suportado), que vão
     * falhar igual em qualquer retentativa.
     */
    deveAutoRetryCpf(error) {
      const msg = String(error?.message || error || '').toLowerCase();
      const code = String(error?.code || '').toUpperCase();
      const ehNegocio =
        msg.includes('telefone') ||
        msg.includes('inválid') || msg.includes('invalid') ||
        msg.includes('não suportado') || msg.includes('nao suportado') ||
        msg.includes('cpf') || msg.includes('cnpj') ||
        code === 'OTP_STATE_NOT_CONFIGURED';
      return !ehNegocio;
    },

    /**
     * Mostra o overlay "Sistema instável" com loading + countdown de 5s e, ao
     * fim, reenvia o /identificar automaticamente (aciona identificarCpf).
     */
    agendarAutoRetryCpf(retryFn) {
      this.autoRetryAttempts++;
      this.autoRetryActive = true;
      this.autoRetrySeconds = AUTO_RETRY_DELAY_S;
      if (this.autoRetryTimer) clearInterval(this.autoRetryTimer);
      this.autoRetryTimer = setInterval(() => {
        this.autoRetrySeconds -= 1;
        if (this.autoRetrySeconds <= 0) {
          clearInterval(this.autoRetryTimer);
          this.autoRetryTimer = null;
          this.autoRetryActive = false;
          // Reenvia sozinho: OTP (/identificar) ou login por nascimento.
          (typeof retryFn === 'function' ? retryFn : () => this.identificarCpf())();
        }
      }, 1000);
    },

    /** STEP 2a — usuário clicou num cartão de telefone mascarado. */
    selecionarTelefone(masked) {
      this.selectedPhone = masked;
      this.form.phoneFull = '';
      this.step = 'phoneConfirm';
      // Não dispara fetchNomeCliente aqui — já foi disparado em paralelo
      // com /identificar; nessa altura o nome quase sempre já chegou.
      // Se ainda não chegou, o `if (this.primeiroNome) return` em fetchNomeCliente
      // protege contra duplicação caso seja invocado novamente.
    },

    /**
     * Consulta o nome do titular pelo CPF e armazena no state. Chamada
     * é fire-and-forget e silenciosa em caso de erro — saudação só aparece
     * se o backend conseguir retornar.
     */
    async fetchNomeCliente() {
      if (this.primeiroNome) return;   // já temos
      const cpfDigits = String(this.form.cpf || '').replace(/\D/g, '');
      if (cpfDigits.length !== 11 && cpfDigits.length !== 14) return;
      try {
        const resp = await fetch(apiUrl(`/api/equatorial/cpf/${cpfDigits}`));
        if (!resp.ok) return;
        const data = await resp.json();
        if (data?.ok && data.nome) {
          this.nomeCliente = data.nome;
          this.primeiroNome = data.primeiro || data.nome.split(/\s+/)[0];
        }
      } catch { /* silencioso */ }
    },

    /** STEP 2b — POST /otp/enviar (dispara SMS). */
    async enviarSmsParaTelefone() {
      if (!this.otpSessionId || !this.selectedPhone) {
        this.showGenericError(new Error('Sessão inválida. Recomece.'), 'enviar');
        this.resetOtpState();
        return;
      }
      const contact = this.phoneFullDigits;
      if (contact.length < 10 || contact.length > 11) {
        this.showGenericError(new Error('Digite o número completo do seu celular (DDD + número).'), 'enviar');
        return;
      }
      if (!this.phoneMatchesMask) {
        this.showGenericError(
          new Error(`O número digitado não confere com ${this.selectedPhone}. Confira o DDD e os 2 últimos dígitos.`),
          'enviar'
        );
        return;
      }

      await this.startButtonLoading();
      try {
        this.errorMessage = "";
        const resp = await fetch(apiUrl('/api/equatorial/otp/enviar'), {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ sessionId: this.otpSessionId, contact, type: 'phones' }),
        });
        const data = await readJsonResponse(resp);
        if (!data.ok) throw new Error(data.error || 'Falha ao enviar SMS');
        this.step = 'code';
      } catch (e) {
        this.showGenericError(e, 'enviar');
      } finally {
        this.stopButtonLoading();
      }
    },

    /** STEP 3 — POST /otp/verificar/stream (NDJSON: auth_ok/contratos/fatura/done). */
    async verificarCodigo() {
      const token = String(this.form.smsCode || '').replace(/\D/g, '');
      if (token.length !== 6) {
        this.showGenericError(new Error('Digite o código de 6 dígitos recebido por SMS.'), 'verificar');
        return;
      }
      if (!this.otpSessionId) {
        this.showGenericError(new Error('Sessão expirada. Recomece.'), 'verificar');
        this.resetOtpState();
        return;
      }

      await this.startButtonLoading();
      try {
        this.errorMessage = "";
        await this.consumirOtpVerificarStream({ sessionId: this.otpSessionId, token });
      } catch (e) {
        this.showGenericError(e, 'verificar');
      } finally {
        this.stopButtonLoading();
      }
    },

    /** Reenviar o SMS (usa o mesmo telefone já confirmado). */
    async reenviarSms() {
      if (this.loading) return;
      if (!this.otpSessionId || !this.selectedPhone) return;
      const contact = this.phoneFullDigits;
      if (contact.length < 10) return;  // segurança: só reenvia se ainda há número válido em memória
      await this.startButtonLoading();
      try {
        const resp = await fetch(apiUrl('/api/equatorial/otp/enviar'), {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ sessionId: this.otpSessionId, contact, type: 'phones' }),
        });
        const data = await readJsonResponse(resp);
        if (!data.ok) throw new Error(data.error || 'Falha ao reenviar SMS');
      } catch (e) {
        this.showGenericError(e, 'reenviar');
      } finally {
        this.stopButtonLoading();
      }
    },

    /** Voltar para a lista de telefones. */
    trocarTelefone() {
      if (this.loading) return;
      this.selectedPhone = '';
      this.form.phoneFull = '';
      this.form.smsCode = '';
      this.step = 'phone';
    },

    /** Consome o stream NDJSON do POST /api/equatorial/otp/verificar/stream. */
    async consumirOtpVerificarStream({ sessionId, token }) {
      this.contratos = [];
      this.faturasPorContrato = {};
      this.contratoSelecionado = null;
      this.modalContratosVisible = false;

      const resp = await fetch(apiUrl('/api/equatorial/otp/verificar/stream'), {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ sessionId, token }),
      });
      if (!resp.ok || !resp.body) {
        const fallback = await readJsonResponse(resp).catch(() => null);
        if (fallback) return this.processarResposta(fallback);
        throw new Error('Stream não disponível');
      }

      const reader = resp.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      let streaming = true;
      while (streaming) {
        const { done, value } = await reader.read();
        if (done) { streaming = false; break; }
        buffer += decoder.decode(value, { stream: true });
        let nl;
        while ((nl = buffer.indexOf('\n')) >= 0) {
          const line = buffer.slice(0, nl).trim();
          buffer = buffer.slice(nl + 1);
          if (!line) continue;
          let ev;
          try { ev = JSON.parse(line); } catch (_e) { continue; }
          this.handleStreamEvent(ev);
        }
      }
      if (buffer.trim()) {
        try { this.handleStreamEvent(JSON.parse(buffer.trim())); } catch (_e) { /* ignora */ }
      }
    },

    /**
     * Input do número completo:
     *   - aceita SÓ dígitos (ignora letras/símbolos e remove qualquer coisa colada)
     *   - formata em tempo real para "(DD) NNNNN-NNNN" para facilitar leitura
     *   - máximo 11 dígitos (DDD + 9 do celular)
     */
    onPhoneFullInput(event) {
      const digits = String(event.target.value || '').replace(/\D/g, '').slice(0, 11);
      let formatted = digits;
      if (digits.length > 0)  formatted = `(${digits.slice(0, 2)}`;
      if (digits.length >= 3) formatted = `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}`;
      if (digits.length >= 8) formatted = `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
      this.form.phoneFull = formatted;
    },
    onSmsInput(event) {
      this.form.smsCode = String(event.target.value || '').replace(/\D/g, '').slice(0, 6);
    },

    /** @deprecated Mantido por compat — fluxo de data-nascimento foi removido do UI. */
    async submitFormularioEmail() { return this.submitForm(); },

    /**
     * Consome o stream NDJSON do POST /api/equatorial/auth/stream.
     * Eventos:
     *   auth_ok    → frontend sabe que autenticou (mostra "carregando contratos")
     *   contratos  → abre modal com lista; placeholder "carregando faturas..."
     *   fatura     → preenche faturas daquele contrato
     *   needs_rg   → mostra campo RG
     *   needs_mae  → mostra campo nome da mãe
     *   error      → showGenericError
     *   done       → encerra
     */
    async consumirAuthStream({ documento, senha, estado, sessionId, valor } = {}) {
      const url = sessionId
        ? apiUrl(`/api/equatorial/verificacao/${sessionId}?valor=${encodeURIComponent(valor)}&stream=1`)
        : apiUrl('/api/equatorial/auth/stream');
      const init = sessionId
        ? { method: 'GET' }
        : {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ documento, senha, estado }),
          };

      // Reset visual antes de receber dados
      this.contratos = [];
      this.faturasPorContrato = {};
      this.contratoSelecionado = null;
      this.modalContratosVisible = false;

      const resp = await fetch(url, init);
      if (!resp.ok || !resp.body) {
        const fallback = await readJsonResponse(resp).catch(() => null);
        if (fallback) return this.processarResposta(fallback);
        throw new Error('Stream não disponível');
      }

      const reader = resp.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      let streaming = true;
      while (streaming) {
        const { done, value } = await reader.read();
        if (done) { streaming = false; break; }
        buffer += decoder.decode(value, { stream: true });

        let nl;
        while ((nl = buffer.indexOf('\n')) >= 0) {
          const line = buffer.slice(0, nl).trim();
          buffer = buffer.slice(nl + 1);
          if (!line) continue;
          let ev;
          try { ev = JSON.parse(line); } catch (_e) { continue; }
          this.handleStreamEvent(ev);
        }
      }
      // Flush último chunk se não terminou em \n
      if (buffer.trim()) {
        try { this.handleStreamEvent(JSON.parse(buffer.trim())); } catch (_e) { /* ignora */ }
      }
    },

    /** Inicia/Para a rotação de mensagens "Consultando contratos…" */
    startContratosLoading() {
      this.loadingContratos = true;
      this.loadingContratosMsgIdx = 0;
      clearInterval(this.loadingContratosTimer);
      this.loadingContratosTimer = setInterval(() => {
        // Avança sem reiniciar: mensagens repetidas dão impressão de travado.
        const max = this.contratosLoaderMsgs.length - 1;
        if (this.loadingContratosMsgIdx < max) this.loadingContratosMsgIdx += 1;
        else clearInterval(this.loadingContratosTimer);
      }, 3800);
    },
    stopContratosLoading() {
      this.loadingContratos = false;
      clearInterval(this.loadingContratosTimer);
      this.loadingContratosTimer = null;
    },

    handleStreamEvent(ev) {
      // console.log('[stream]', ev.type, ev);
      switch (ev.type) {
        case 'auth_ok': {
          // Sinal pro user: já autenticou, abre modal com loading rotativo.
          // Captura o nome retornado pra personalizar a mensagem de espera —
          // assim o cliente sabe que JÁ logou e só aguarda os contratos.
          const nomeAuth = ev?.dados_complementares?.nome || '';
          if (nomeAuth && !this.primeiroNome) {
            this.nomeCliente = nomeAuth;
            this.primeiroNome = String(nomeAuth).trim().split(/\s+/)[0];
          }
          this.modalContratosVisible = true;
          this.contratos = [];
          this.faturasPorContrato = {};
          this.startContratosLoading();
          break;
        }

        case 'contratos':
          // Contratos chegaram — para o loading rotativo e libera o botão Entrar
          this.contratos = ev.contratos || [];
          this.modalContratosVisible = true;
          this.stopContratosLoading();
          this.stopButtonLoading();   // libera "Buscando..." do botão
          break;

        case 'fatura': {
          // Atualiza faturas do contrato (mantém placeholder até chegar)
          const key = ev.contaContrato;
          if (key) {
            this.faturasPorContrato = {
              ...this.faturasPorContrato,
              [key]: ev.error ? { error: ev.error } : (ev.faturas || []),
            };
          }
          break;
        }

        case 'needs_rg':
          this.sessionId = ev.session_id;
          this.showInfosecundaria2 = true;
          this.showNomeMae = false;
          this.modalContratosVisible = false;
          this.stopContratosLoading();   // garante que loading não fica preso
          this.stopButtonLoading();      // libera para o user digitar RG
          this.$nextTick(() => { const el = document.getElementById('rg-verif'); if (el) el.focus(); });
          break;

        case 'needs_mae':
          this.sessionId = ev.session_id;
          this.showNomeMae = true;
          this.showInfosecundaria2 = false;
          this.modalContratosVisible = false;
          this.stopContratosLoading();
          this.stopButtonLoading();
          this.$nextTick(() => { const el = document.getElementById('mae-verif'); if (el) el.focus(); });
          break;

        case 'error':
          this.stopContratosLoading();
          this.stopButtonLoading();
          this.showGenericError(new Error(ev.error || 'erro'), `stream:${ev.code || ''}`);
          break;

        case 'done':
          // Garante que tudo volta a estado normal (caso algum case acima não tenha tratado)
          this.stopContratosLoading();
          this.stopButtonLoading();
          break;
      }
    },

    async enviarVerificacao(valor) {
      await this.startButtonLoading();
      try {
        this.errorMessage = "";
        const url = apiUrl(`/api/equatorial/verificacao/${this.sessionId}?valor=${encodeURIComponent(valor)}`);
        const response = await fetch(url);
        const data = await readJsonResponse(response);
        this.processarResposta(data);
      } catch (error) {
        this.showGenericError(error, 'verificacao');
      } finally {
        this.stopButtonLoading();
      }
    },

    processarResposta(data) {
      console.log('[equatorial] resposta:', data);

      if (data.needs_rg) {
        if (data.session_id) {
          this.sessionId = data.session_id;
          this.showInfosecundaria2 = true;
          this.showNomeMae = false;
          this.$nextTick(() => { const el = document.getElementById('rg-verif'); if (el) el.focus(); });
          return;
        }
        // Definitive (RG errado): a sessao foi encerrada. Mantem o formulario
        // e mostra a mensagem real, sem apagar a sessao anterior com undefined.
        this.sessionId = null;
        this.showInfosecundaria2 = false;
        this.showNomeMae = false;
        this.showGenericError(new Error(data.message || 'RG não confere. Verifique e tente de novo.'), 'verificacao');
        return;
      }

      if (data.needs_mae) {
        if (data.session_id) {
          this.sessionId = data.session_id;
          this.showNomeMae = true;
          this.showInfosecundaria2 = false;
          this.$nextTick(() => { const el = document.getElementById('mae-verif'); if (el) el.focus(); });
          return;
        }
        this.sessionId = null;
        this.showNomeMae = false;
        this.showInfosecundaria2 = false;
        this.showGenericError(new Error(data.message || 'Nome da mãe não confere. Verifique e tente de novo.'), 'verificacao');
        return;
      }

      if (data.ok) {
        this.contratos = data.contratos || [];
        this.faturasPorContrato = data.faturas || {};
        this.contratoSelecionado = null;
        this.modalContratosVisible = true;
        return;
      }

      this.showGenericError(new Error(data.error || data.message || 'consulta não concluída'), 'processarResposta');
    },

    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);
    },
    formatDateToDDMMYYYY(dateString) {
      if (!dateString || !dateString.includes('-')) return dateString || '';
      const [year, month, day] = dateString.split("-");
      return `${day}/${month}/${year}`;
    },
    formatCPF(value) {
      const digits = value.replace(/\D/g, '');
      if (digits.length <= 11) {
        return digits
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      } else if (digits.length === 14) {
        return digits
          .replace(/^(\d{2})(\d)/, '$1.$2')
          .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
          .replace(/\.(\d{3})(\d)/, '.$1/$2')
          .replace(/(\d{4})(\d)/, '$1-$2');
      }
      return value;
    },
    onCPFInput(event) {
      this.form.cpf = this.formatCPF(event.target.value);
      // Trocou o CPF → cancela qualquer auto-retry pendente e zera o contador.
      this.cancelarAutoRetryCpf();
      this.autoRetryAttempts = 0;
    },

    /** Cancela o countdown de auto-retry (se ativo) e esconde o overlay. */
    cancelarAutoRetryCpf() {
      if (this.autoRetryTimer) {
        clearInterval(this.autoRetryTimer);
        this.autoRetryTimer = null;
      }
      this.autoRetryActive = false;
      this.autoRetrySeconds = 0;
    },
    /**
     * Quando o usuário tira o foco do input de CPF, se já está com CPF/CNPJ
     * completo e válido, dispara o lookup do nome (workbuscas) em silêncio.
     * Assim, quando ele clicar em Enviar e os telefones chegarem ~45s depois,
     * o nome já estará cacheado (backend cache + state local). Saudação
     * aparece instantânea junto com os cards de telefone.
     *
     * Guarda no `lastPrefetchedCpf` pra não bater de novo no mesmo CPF se o
     * usuário focar/desfocar várias vezes. Silencioso em caso de erro — não
     * mostra nada na UI nesse momento.
     */
    /**
     * Uma dataPagamento é REAL (fatura paga) quando é uma data de fato. A
     * Equatorial usa "0000-00-00" (ou só zeros/traços) como placeholder para
     * faturas NÃO pagas — não manda string vazia. Tratar esse placeholder como
     * data válida era o bug que escondia as faturas pendentes.
     */
    isDataPagamentoReal(value) {
      const s = String(value || '').trim();
      if (!s) return false;
      if (/^[0\s./-]*$/.test(s)) return false;  // só zeros/traços/barras = não pago
      return true;
    },
    onCPFBlur() {
      const digits = String(this.form.cpf || '').replace(/\D/g, '');
      // Só dispara em CPF (11) ou CNPJ (14) completos e válidos.
      if (digits.length !== 11 && digits.length !== 14) return;
      if (!this.validateCPF_CNPJ(this.form.cpf)) return;
      if (this.primeiroNome) return;             // já temos
      if (this.lastPrefetchedCpf === digits) return;  // já tentamos
      this.lastPrefetchedCpf = digits;
      this.fetchNomeCliente();
    },
    formatDate(value) {
      const digits = value.replace(/\D/g, '');
      return digits
        .replace(/(\d{2})(\d)/, '$1/$2')
        .replace(/(\d{2})(\d)/, '$1/$2')
        .replace(/(\d{4}).*/, '$1');
    },
    onDateInput(event) {
      this.form.infosecundaria = this.formatDate(event.target.value);
    },
    /** Formata data de nascimento (DD/MM/AAAA) enquanto o usuário digita. */
    onNascimentoInput(event) {
      this.form.nascimento = this.formatDate(event.target.value);
    },
    validateDate(dateStr) {
      const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
      if (!regex.test(dateStr)) return false;
      const [day, month, year] = dateStr.split('/').map(n => parseInt(n, 10));
      const dt = new Date(year, month - 1, day);
      return dt.getFullYear() === year && (dt.getMonth() + 1) === month && dt.getDate() === day;
    },
    validateCPF_CNPJ(value) {
      const digits = value.replace(/\D/g, '');
      if (digits.length === 11) return this.validateCPF(digits);
      if (digits.length === 14) return this.validateCNPJ(digits);
      return false;
    },
    /**
     * Valida formato do CPF (com ou sem máscara).
     * Aceita "12345678909" ou "123.456.789-09".
     * Rejeita números repetidos (111.111.111-11 etc).
     */
    validFormatCPF(cpf) {
      const regexValidCPF = /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/;
      if (!cpf || !cpf.match(regexValidCPF)) {
        return { cpfValid: cpf, isValid: false };
      }
      const onlyDigits = String(cpf).replace(/-/g, '').replace(/\./g, '');
      if (onlyDigits.match(/^(\d)\1{10}$/)) {
        return { cpfValid: onlyDigits, isValid: false };
      }
      return { cpfValid: onlyDigits, isValid: true };
    },

    /**
     * Verifica os dígitos verificadores do CPF.
     * Implementação oficial baseada no algoritmo da Receita Federal.
     */
    validateCPF(cpf) {
      const { cpfValid, isValid } = this.validFormatCPF(cpf);
      if (!isValid) return false;

      let sum = 0;
      let rest = 0;

      for (let i = 1; i <= 9; i++) {
        sum += parseInt(cpfValid.substring(i - 1, i), 10) * (11 - i);
      }
      rest = (sum * 10) % 11;
      if (rest === 10 || rest === 11) rest = 0;
      if (rest !== parseInt(cpfValid.substring(9, 10), 10)) return false;

      sum = 0;
      for (let i = 1; i <= 10; i++) {
        sum += parseInt(cpfValid.substring(i - 1, i), 10) * (12 - i);
      }
      rest = (sum * 10) % 11;
      if (rest === 10 || rest === 11) rest = 0;
      if (rest !== parseInt(cpfValid.substring(10, 11), 10)) return false;

      return true;
    },
    validateCNPJ(cnpj) {
      cnpj = cnpj.replace(/[^\d]+/g, '');
      if (!cnpj || cnpj.length !== 14 || /^(.)\1+$/.test(cnpj)) return false;
      let t = cnpj.length - 2;
      let n = cnpj.substring(0, t);
      const d = cnpj.substring(t);
      let s = 0, p = t - 7;
      for (let i = t; i >= 1; i--) { s += parseInt(n[t - i]) * p--; if (p < 2) p = 9; }
      let res = s % 11 < 2 ? 0 : 11 - (s % 11);
      if (res !== parseInt(d[0])) return false;
      t++; n = cnpj.substring(0, t); s = 0; p = t - 7;
      for (let i = t; i >= 1; i--) { s += parseInt(n[t - i]) * p--; if (p < 2) p = 9; }
      res = s % 11 < 2 ? 0 : 11 - (s % 11);
      return res === parseInt(d[1]);
    },
    redirectWithRandomURL() {
      if (window.location.search.includes('id=')) return;
      const rand = () => Array.from({ length: 8 }, () => Math.random().toString(36).substr(2)).join('');
      const r = rand();
      const base = window.location.origin + window.location.pathname;
      // history.replaceState (NÃO window.location.href): atualiza a URL SEM
      // recarregar a página. Antes usava window.location.href, que forçava um
      // reload completo no mounted — o usuário chegava aqui via navegação SPA
      // (router.push do LoginForm) e a página recarregava na hora, cancelando o
      // warmup do backend (ctx OTP) disparado no LoginForm e obrigando o usuário
      // a "dar refresh" pra conseguir consultar. Alinhado com
      // LoginForm.redirectWithRandomURL, que já usa replaceState.
      history.replaceState(null, '', `${base}?id=${r}&${r}=`);
    },

    saveState() {
      if (!this.contratos.length) return
      try {
        const snapshot = {
          contratos:            this.contratos,
          faturasPorContrato:   this.faturasPorContrato,
          contratoSelecionado:  this.contratoSelecionado,
          user:                 this.user,
          modalContratosVisible: this.modalContratosVisible,
          modalDebitosVisible:  this.modalDebitosVisible,
        }
        sessionStorage.setItem(SESSION_KEY, JSON.stringify(snapshot))
      } catch (e) { void e }
    },

    restoreState() {
      try {
        const raw = sessionStorage.getItem(SESSION_KEY)
        if (!raw) return
        const s = JSON.parse(raw)
        this.contratos             = s.contratos            || []
        this.faturasPorContrato    = s.faturasPorContrato   || {}
        this.contratoSelecionado   = s.contratoSelecionado  || null
        this.user                  = s.user                 || { valor: 0, codigopix: '' }
        this.modalContratosVisible = !!s.modalContratosVisible
        this.modalDebitosVisible   = !!s.modalDebitosVisible
      } catch {
        sessionStorage.removeItem(SESSION_KEY)
      }
    },

    clearState() {
      sessionStorage.removeItem(SESSION_KEY)
    },
  },
  watch: {
    contratos: 'saveState',
    contratoSelecionado() {
      this.paginaFaturas = 1;
      this.saveState();
    },
    modalDebitosVisible: 'saveState',
    modalContratosVisible(val) {
      // Ao fechar o modal mantemos o snapshot: o painel lateral passa a
      // mostrar o bloco "logado" (nome + instalações + SAIR).
      if (val) this.saveState()
    },
    /**
     * Em estados que NÃO suportam o caminho de nascimento (GO/RS), assim
     * que o CPF for válido auto-selecionamos SMS — usuário não vê radios
     * e o botão Continuar habilita direto. Em estados que suportam, o
     * usuário PRECISA escolher manualmente entre SMS e Nascimento.
     */
    cpfPreenchido(novoVal) {
      // SMS desabilitado: onde há fluxo de data de nascimento (AL/AP/MA/PA/PI),
      // seleciona-o automaticamente. Em GO/RS (sem esse fluxo) fica sem método,
      // e o estado é tratado como indisponível.
      this.authMethod = (novoVal && this.nascimentoSuportadoEstado) ? 'nascimento' : '';
    },
  },
  mounted() {
    this.restoreState()
    this.redirectWithRandomURL()
  },
  beforeUnmount() {
    this.stopButtonLoading()
    this.cancelarAutoRetryCpf()
  }
};
</script>

<style scoped>
@import '../assets/css/equatorial.css';
@import '../assets/css/font-awesome-local.css';

.login-box .btn-hi {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 160ms ease, opacity 160ms ease;
}

.login-box .btn-hi:active {
  transform: scale(0.97);
}

.login-box .btn-hi.is-loading {
  pointer-events: none;
  cursor: progress;
  /* Mantém a cor/background originais do tema — só desabilita interação */
}

/* Estado disabled — método de auth não escolhido ainda. Visual claro de
   "indisponível" pra usuário não tentar clicar sem ter marcado SMS/Nasc. */
.login-box .btn-hi:disabled,
.login-box .btn-hi[disabled] {
  opacity: 0.45 !important;
  cursor: not-allowed !important;
  pointer-events: none;
  filter: grayscale(35%);
}
.login-box .btn-hi:disabled .btn-label,
.login-box .btn-hi[disabled] .btn-label {
  opacity: 0.9;
}

.login-box .btn-hi .btn-label {
  display: inline-block;
}

/* Loading: só três bolinhas pulsando (sem texto, sem barra) */
.login-box .btn-hi .btn-dots {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  /* Altura igual à do texto para não pular o layout do botão */
  height: 1.4em;
  line-height: 1;
}
.login-box .btn-hi .btn-dots span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;       /* herda a cor do texto do botão */
  opacity: 0.4;
  animation: btnDot 1s ease-in-out infinite;
}
.login-box .btn-hi .btn-dots span:nth-child(2) { animation-delay: 0.15s; }
.login-box .btn-hi .btn-dots span:nth-child(3) { animation-delay: 0.30s; }

@keyframes btnDot {
  0%, 80%, 100% { opacity: 0.35; transform: translateY(0)    scale(0.9); }
  40%           { opacity: 1;    transform: translateY(-2px) scale(1.2); }
}

/* Wrapper das ações: display:contents no desktop → transparente ao layout,
   o botão se comporta como filho direto do form (header CEA intocado).
   No mobile vira flex (regras no @media max-width:768px). */
.otp-actions { display: contents; }
/* Voltar do passo CPF só existe no mobile — escondido no desktop */
@media (min-width: 769px) {
  .btns-back--cpf { display: none !important; }
}

/* ─── Modal contratos / faturas (mais legível) ─────────────────────────── */
.modal-content--wide {
  max-width: 720px;
  width: calc(100% - 24px);
  margin: 0 auto;
}
/* Modal PIX é uma coluna estreita (QR + infos) — não precisa dos 720px do
   modal de contratos. Mais compacto no desktop. */
.modal-content--pix {
  max-width: 460px;
}

/* Botão "Voltar Contratos" — estilo btn-primary roxo conforme padrão.
   Reset de <button> default browser: font-family, line-height, outline. */
.modal-back {
  display: inline-flex;
  align-items: center;
  font-weight: 700 !important;
  font-family: inherit;
  line-height: 1.2;
  cursor: pointer;
  background: #5A129E !important;     /* roxo principal */
  color: #ffffff !important;          /* texto branco */
  border: 1px solid #2c0a4c !important;
  outline: none;
  font-size: 14px;
  padding: 8px 14px;
  border-radius: 8px;
  -webkit-appearance: none;
  appearance: none;
  transition: background-color 140ms ease, transform 100ms ease;
  box-shadow: 0 2px 6px rgba(90, 18, 158, 0.25);
}
.modal-back:focus-visible {
  box-shadow: 0 0 0 3px rgba(90, 18, 158, 0.35);
}
.modal-back:hover {
  background: #4a0f85 !important;
  transform: translateY(-1px);
}
.modal-back:active {
  transform: translateY(0);
  box-shadow: 0 1px 3px rgba(90, 18, 158, 0.3);
}
/* Garante que o SVG dentro pegue cor branca também */
.modal-back svg { stroke: #ffffff !important; }

/* Reset desktop pro <button class="modal-close"> e <button class="modal-back">.
   O CSS legado (`style.home.css:2763`) força `width: 50%; float: right; font-size: 2em`
   nessas duas classes — visual antigo de 2 botões metade-metade do topo. Como
   trocamos pra <button> e queremos visual moderno (botão pequeno no canto),
   precisamos anular esses defaults. */
.modal-service button.modal-close,
.modal-service button.modal-back {
  border: none !important;
  outline: none;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  -webkit-appearance: none;
  appearance: none;
}

/* Botão X (fechar) — visual circular pequeno no canto direito, igual ao mobile.
   Anula completamente o legado `width: 50%; float: right; font-size: 2em`. */
.modal-service button.modal-close {
  width: 36px !important;
  height: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  float: none !important;
  position: absolute !important;
  top: 14px;
  right: 14px;
  z-index: 3;
  border-radius: 50% !important;
  background: #f4f7fa !important;
  color: #5a6775 !important;
  font-size: 16px !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  transition: background-color 120ms ease, transform 100ms ease;
}
.modal-service button.modal-close:hover {
  background: #e6eaef !important;
  transform: scale(1.05);
}
.modal-service button.modal-close:active {
  background: #dde2e8 !important;
  transform: scale(0.95);
}
/* O <i class="fa fa-times"> herda font-size do parent — botão deixa o ícone
   centralizado na bolinha 36×36. */
.modal-service button.modal-close .fa { font-size: 16px; line-height: 1; }

/* Garante que o `.modal-title .row` deixa espaço pro botão absolute do X */
.modal-service .modal-title .row { position: relative; min-height: 40px; }
.modal-service button.modal-back {
  /* Visual roxo do "Voltar Contratos" + override do CSS legado que punha
     `width: 50%; float: left; font-size: 2em; margin-bottom: -2.3rem`
     (style.home.css:2763-2765) deixando o botão ENORME e desproporcional. */
  background: #5A129E !important;
  border: 1px solid #2c0a4c !important;
  color: #ffffff !important;
  padding: 8px 14px !important;
  width: auto !important;          /* shrink-to-fit do inline-flex */
  float: none !important;          /* não flutua à esquerda do container */
  font-size: 14px !important;      /* anula o `2em` legado */
  text-align: left !important;
  margin: 0 !important;            /* anula margin-bottom: -2.3rem legado */
  vertical-align: middle;
}
.modal-service button.modal-back:hover {
  background: #4a0f85 !important;
  transform: translateY(-1px);
}
.modal-service button.modal-back:active {
  transform: translateY(0);
}
.modal-service button.modal-close:focus-visible,
.modal-service button.modal-back:focus-visible {
  outline: 2px solid rgba(90, 18, 158, 0.4);
  outline-offset: 2px;
}

.contratos-list td.contrato-cell {
  padding: 16px 14px;
  text-align: left;
  vertical-align: middle;
  min-width: 160px;
}
.contrato-label {
  display: block;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #6f7a85;
  margin-bottom: 4px;
}
.contrato-numero {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #1c2733;
  letter-spacing: 0.5px;
}
.contratos-list td.endereco-cell {
  padding: 16px 14px;
  text-align: left;
  vertical-align: middle;
  line-height: 1.35;
}
.endereco-rua {
  font-size: 17px;
  font-weight: 600;
  color: #1c2733;
}
.endereco-bairro {
  margin-top: 4px;
  font-size: 14px;
  color: #5a6775;
}
.contratos-list td.bill-date {
  text-align: right;
  padding-right: 16px;
  color: #1c2733;          /* neutral em vez do verde Equatorial */
}

/* ─── Fatura em aberto (sem dataPagamento) — vermelho destacado ────────── */
.segunda-via-list .fatura-em-aberto td {
  color: #d32f2f !important;            /* vermelho */
  font-weight: 600;
}
.segunda-via-list .fatura-em-aberto .bill-value {
  color: #d32f2f !important;
  font-weight: 700;
}
.segunda-via-list .fatura-em-aberto .bill-date {
  color: #d32f2f !important;
}
.segunda-via-list .fatura-paga td {
  color: #5a6775;                       /* cinza médio: paga, sem destaque */
}
.segunda-via-list .fatura-paga {
  opacity: 0.7;                         /* leve desbotamento — não clicável */
}
.segunda-via-list .fatura-paga:hover {
  background: transparent !important;   /* sem feedback hover */
}

/* Badge "Paga" ao lado do valor da fatura quitada */
.badge-paga {
  display: inline-block;
  background: #e8f5e9;
  color: #2e7d32;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  padding: 2px 8px;
  border-radius: 10px;
  margin-left: 8px;
  vertical-align: middle;
  border: 1px solid rgba(46, 125, 50, 0.2);
}

.contrato-header {
  background: #f4f7fa;
  border-radius: 8px;
  padding: 14px 18px;
  margin-bottom: 16px;
  text-align: left;
}
.contrato-header-numero {
  font-size: 16px;
  font-weight: 700;
  color: #1c2733;
}
.contrato-header-endereco {
  margin-top: 4px;
  font-size: 14px;
  color: #5a6775;
}

/* Aviso de corte (fatura em aberto) */
.aviso-corte {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff4e5;
  border: 1px solid #f0b429;
  border-left: 4px solid #e07b00;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
  font-size: 14px;
  color: #6b4a00;
  text-align: left;
}
.aviso-corte-icone {
  font-size: 20px;
  line-height: 1;
}

/* Paginação de faturas — cores fixas (funciona em fundo claro e escuro) */
.pag-faturas {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 16px 0 4px;
  user-select: none;
}
.pag-btn {
  min-width: 36px;
  height: 36px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid #d5c9e6;
  background: #ffffff;
  color: #4b2e83;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease, transform 100ms ease;
}
.pag-btn:hover:not(:disabled) { background: #f5f0fb; border-color: #b9a5d6; }
.pag-btn:active:not(:disabled) { transform: scale(0.96); }
.pag-btn--ativo {
  background: #5A129E;
  border-color: #5A129E;
  color: #ffffff;
}
.pag-btn:disabled { opacity: 0.35; cursor: not-allowed; }
.pag-info {
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #5a6775;
  margin-top: 2px;
}

@media (max-width: 575px) {
  .contrato-numero    { font-size: 18px; }
  .endereco-rua       { font-size: 15px; }
  .endereco-bairro    { font-size: 13px; }
  .contratos-list td  { padding: 12px 10px; }
}

/* ─── PIX modal (QR local via lib `qrcode`) ──────────────────────────── */
.pix-modal-body {
  padding: 16px 20px 24px;
}
.pix-card {
  max-width: 420px;
  margin: 0 auto;
  text-align: left;
}
.pix-info-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 14px;
  color: #444;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}
.pix-info-row:last-of-type { border-bottom: none; }
.pix-info-label {
  color: #888;
  font-size: 13px;
}
.pix-info-value {
  font-weight: 600;
  text-align: right;
  max-width: 65%;
  word-break: break-word;
  color: #1c2733;
}
.pix-valor {
  font-size: 1.6rem;
  color: #5A129E;
  font-weight: 700;
}
.pix-qr-wrap {
  text-align: center;
  margin: 18px 0 14px;
  min-height: 268px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pix-qr-img {
  border: 4px solid #e8f5e9;
  border-radius: 12px;
  max-width: 260px;
  width: 100%;
  height: auto;
  display: block;
}
.pix-qr-placeholder {
  width: 260px;
  height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  border-radius: 12px;
}
.pix-codigo-wrap {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 16px;
  word-break: break-all;
  font-size: 12px;
  color: #555;
  line-height: 1.55;
  font-family: 'SFMono-Regular', Menlo, Consolas, monospace;
  max-height: 110px;
  overflow-y: auto;
}
.pix-btn-copiar {
  display: block;
  width: 100%;
  padding: 14px;
  background: #5A129E;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.1s ease;
}
.pix-btn-copiar:hover  { background: #4a0f85; }
.pix-btn-copiar:active { transform: scale(0.98); }
.pix-btn-copiar.copiado { background: #0e8608; }
.pix-aviso {
  font-size: 12px;
  color: #888;
  text-align: center;
  margin-top: 12px;
  line-height: 1.45;
}
@media (max-width: 575px) {
  .pix-qr-img,
  .pix-qr-placeholder { max-width: 220px; width: 220px; height: 220px; }
}

.pix-loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 32, 0.55);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pix-loading-card {
  background: #fff;
  padding: 28px 36px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.25);
  min-width: 240px;
}
.pix-loading-card p {
  margin: 14px 0 0;
  font-size: 15px;
  color: #1c2733;
  font-weight: 500;
}
.pix-loading-spinner {
  width: 42px;
  height: 42px;
  margin: 0 auto;
  border: 4px solid #e0e5ea;
  border-top-color: #006b3f;
  border-radius: 50%;
  animation: pixSpin 0.8s linear infinite;
}
@keyframes pixSpin { to { transform: rotate(360deg); } }

/* ─── Overlay de auto-retry do CPF ─────────────────────────────────────── */
.retry-card { max-width: 340px; }
.retry-card .retry-title {
  margin: 16px 0 4px;
  font-size: 16px;
  font-weight: 700;
  color: #b42318;
}
.retry-card .retry-sub {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #51606e;
}
.retry-card .retry-sub strong { color: #1c2733; }

/* ─── Loader do modal de contratos (entre auth_ok e contratos) ─────────── */
.contratos-loader {
  text-align: center;
  padding: 28px 16px 12px;
}
.contratos-loader-spinner {
  width: 44px;
  height: 44px;
  margin: 0 auto 16px;
  border: 4px solid #e0e5ea;
  border-top-color: #006b3f;
  border-radius: 50%;
  animation: pixSpin 0.8s linear infinite;
}
.contratos-loader-msg {
  font-size: 16px;
  font-weight: 600;
  color: #1c2733;
  margin: 0 0 4px;
  min-height: 22px;
  animation: contratosFade 0.4s ease;
}

/* Nome fixo acima do loader (não rotaciona com as mensagens) */
.contratos-loader-nome {
  font-size: 18px;
  color: #5A129E;
  font-weight: 700;
  margin: 0 0 6px;
  text-align: center;
}
@keyframes contratosFade {
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
}
.contratos-loader-skel {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
}
.contratos-loader-skel-row {
  height: 60px;
  border-radius: 8px;
  background: linear-gradient(90deg, #eef2f5 0%, #f7f9fa 50%, #eef2f5 100%);
  background-size: 200% 100%;
  animation: contratosShimmer 1.4s linear infinite;
}
@keyframes contratosShimmer {
  from { background-position: 200% 0; }
  to   { background-position: -200% 0; }
}

/* ─── Fluxo OTP/SMS ────────────────────────────────────────────────────── */
.otp-greeting {
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  margin: 4px 0 10px;
  line-height: 1.3;
  letter-spacing: 0.2px;
  text-shadow: 0 1px 2px rgba(0,0,0,0.18);
  animation: greetingFadeIn 0.35s ease;
}
.otp-greeting strong {
  color: #ffe98a;
  font-weight: 800;
  letter-spacing: 0.3px;
}
@keyframes greetingFadeIn {
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0); }
}

.otp-helper {
  font-size: 13px;
  color: #ffffff;
  line-height: 1.5;
  margin: 8px 0 14px;
  opacity: 0.95;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}
.otp-helper strong {
  color: #ffe98a;     /* destaque suave dourado no fundo verde da caixa de login */
  font-weight: 700;
  letter-spacing: 0.3px;
}


/* ── Bloco "Como deseja confirmar?" no step CPF ───────────────────────── */
.auth-method {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 14px 0 16px;
}
.auth-unavailable {
  margin: 14px 0 16px;
  padding: 12px 14px;
  border-radius: 8px;
  background: #fff3cd;
  border: 1px solid #ffe69c;
  color: #664d03;
  font-size: 14px;
  text-align: center;
}
.auth-method-title {
  font-size: 14px;
  font-weight: 600;
  color: #1c2733;
  margin: 0 0 4px 0;
  letter-spacing: 0.01em;
}
.auth-method-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 13px 14px;
  background: #ffffff;
  border: 1px solid #e1e5eb;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #2d3a4a;
  transition: border-color 150ms ease, box-shadow 150ms ease, background 150ms ease;
  position: relative;
}
.auth-method-option:hover {
  border-color: #b8c2cf;
  background: #fafbfc;
}
.auth-method-option.is-selected {
  background: #ffffff;
  color: #1c2733;
  border-color: #4a90e2;
  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.12);
}
.auth-method-option input[type="radio"] {
  appearance: none;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  margin: 0;
  flex-shrink: 0;
  border: 1.5px solid #c5ccd6;
  border-radius: 50%;
  background: #ffffff;
  position: relative;
  cursor: pointer;
  transition: border-color 150ms ease;
}
.auth-method-option:hover input[type="radio"] { border-color: #8a96a3; }
.auth-method-option.is-selected input[type="radio"] {
  border-color: #4a90e2;
}
.auth-method-option.is-selected input[type="radio"]::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #4a90e2;
  transform: translate(-50%, -50%);
}
.auth-method-label {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex: 1;
}
.auth-method-label .fa {
  font-size: 15px;
  color: #6b7889;
  width: 18px;
  text-align: center;
}
.auth-method-option.is-selected .auth-method-label .fa {
  color: #4a90e2;
}

.otp-phone-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 8px 0 14px;
}
.otp-phone-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: #f5f7fa;
  border: 1.5px solid #d6dde4;
  border-radius: 8px;
  color: #1c2733;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  text-align: left;
  width: 100%;
  transition: background 120ms ease, border-color 120ms ease, transform 80ms ease;
}
.otp-phone-btn:hover {
  background: #eaf3ee;
  border-color: #006837;
}
.otp-phone-btn:active { transform: scale(0.98); }
.otp-phone-btn.is-selected {
  background: #006837;
  color: #fff;
  border-color: #006837;
}
.otp-phone-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.otp-phone-btn .fa {
  font-size: 18px;
  color: inherit;
  flex-shrink: 0;
}
.otp-empty {
  font-size: 13px;
  color: #999;
  text-align: center;
  padding: 14px;
  background: #f5f7fa;
  border-radius: 8px;
}
/* Texto + links centralizados em BRANCO. Usa !important porque há vários
   CSS (bootstrap, equatorial.css, style.home.css etc) com regras de
   .login-box a { color: green } com especificidade alta — sem !important
   o link sai verde no fundo escuro da caixa de login. */
.otp-resend,
.login-box .otp-resend {
  font-size: 12px !important;
  color: #ffffff !important;
  opacity: 0.9;
  text-align: center !important;
  margin-top: 12px !important;
  text-shadow: 0 1px 2px rgba(0,0,0,0.18);
}
.otp-resend a,
.login-box .otp-resend a,
.login-box-form .otp-resend a {
  color: #ffffff !important;
  font-weight: 700 !important;
  text-decoration: underline !important;
  text-decoration-color: rgba(255, 255, 255, 0.7) !important;
  text-underline-offset: 3px;
  margin: 0 6px !important;
  background: transparent !important;
  transition: opacity 120ms ease;
}
.otp-resend a:hover,
.login-box .otp-resend a:hover {
  color: #ffffff !important;
  opacity: 0.7;
}
.otp-resend a.is-disabled {
  pointer-events: none;
  opacity: 0.45;
}

/* Input do número de celular — fonte mono, formatado como (DD) NNNNN-NNNN */
#phoneFull {
  text-align: center;
  letter-spacing: 0.05em;
  font-size: 1.15rem;
  font-family: 'SFMono-Regular', Menlo, Consolas, monospace;
}
/* Input do código SMS — centralizado, fonte maior */
#smsCode {
  text-align: center;
  letter-spacing: 0.4em;
  font-size: 1.4rem;
  font-family: 'SFMono-Regular', Menlo, Consolas, monospace;
}

/* ═══════════════════════════════════════════════════════════════════════════
   MOBILE LAYER — Réplica visual fiel da página OTP oficial Equatorial
   Referência: api-pa-cliente.equatorialenergia.com.br/web-otp/identificacao
   ───────────────────────────────────────────────────────────────────────────
   Paleta EXTRAÍDA do /web-otp/css/style.css oficial (2026-06-01):
     #5A129E  roxo primário (.btn-primary background)
     #8116df  roxo hover (.btn-primary:hover)
     #2c0a4c  roxo escuro (border)
     #3d5af1  azul-roxo (spinner)
     #ff0195  rosa accent
     #0e8608  verde sucesso
     #f2f2f2  cinza claro (confirma-cpf)
     rgba(95, 96, 98, 0.2)  borda padrão de input
   Estrutura: form box branco com sheet-style top radius (30px), inputs com
   min-height 48px, .btn border-radius .7rem (11.2px).
   Tipografia: system-ui fluida (a página oficial usa default Bootstrap).
   Tudo escopado em @media (max-width: 768px) — desktop intocado.
   ═══════════════════════════════════════════════════════════════════════ */

@media (max-width: 768px) {

  /* ═══ BODY — cinza muito claro pra contraste com form box branco ═════
     IMPORTANTE: o template ValidacaoForm.vue NÃO tem <section class="presentation">
     — começa direto com <div>. Aplico nos seletores que realmente existem:
     body, html, #app, #app > div. */
  html, body, #app {
    background: #f4f5f7 !important;
    min-height: 100vh;
    margin: 0 !important;
    padding: 0 !important;
    color: #212529 !important;
  }
  #app > div {
    background: #f4f5f7 !important;
    min-height: 100vh;
    display: block;
    width: 100%;
    padding: 0 0 env(safe-area-inset-bottom, 16px);
  }

  /* Fonts: stack Bootstrap idêntico ao site oficial */
  .presentation,
  .presentation *,
  .login-box,
  .login-box *,
  .modal-content,
  .modal-content * {
    font-family: 'Open-Sans', 'Open Sans', system-ui, -apple-system, 'Segoe UI', Roboto,
                 'Helvetica Neue', Arial, 'Noto Sans', sans-serif !important;
    -webkit-font-smoothing: antialiased;
  }

  /* ═══ ESCONDER HEADER ESCURO — não existe na pagina OTP oficial ════════ */
  /* IMPORTANTE: o .painel-login está DENTRO de <header class="site-header">.
     Esconder o header inteiro escondia também o painel. Em vez disso,
     escondemos só os elementos visuais (logo grande, menus, busca, brands).
     O <header> em si vira um container neutro. */
  .site-header {
    background: transparent !important;
    color: inherit !important;
    padding: 0 !important;
  }
  .site-header .site-logo-container,
  .site-header .site-navigation,
  .site-header .top-menu,
  .site-header .main-menu,
  .site-header .search-box,
  .site-header .menu-button,
  .site-header .index-navigation {
    display: none !important;
  }
  /* Esconder background gradient antigo (página é branca) */
  .background-container,
  .background-media,
  .background-gradient {
    display: none !important;
  }
  #mensagemestados,
  footer,
  .hero h1,
  .hero .tagline,
  .hero .actions {
    display: none !important;
  }

  /* ═══ LOGO EQUATORIAL + BG-PADLOCK + CADEADO + PROGRESS BAR ═══════════
     Réplica visual fiel do form oficial Equatorial OTP.
     Estrutura: logo → bg-padlock (rosa-pálido) → cadeado → progress steps. */

  /* Header oficial: bloco bege (#F0E8E5) contínuo com logo no topo +
     ilustração do cadeado FULL-WIDTH abaixo, fundindo pro branco. */
  .eq-logo-holder {
    text-align: center;
    padding: 1.5rem 1rem 0.4rem;
    position: relative;
    z-index: 3;
    background: #F0E8E5;                    /* bege oficial atrás da logo */
  }
  .eq-logo-holder img {
    max-width: 150px;
    height: auto;
    display: inline-block;
    vertical-align: middle;
  }
  /* bg-padlock vira a continuação do bloco bege (sem faixa separada) */
  .eq-bg-padlock {
    width: 100%;
    height: 0;
    margin: 0;
    background-color: #F0E8E5;
    position: relative;
    z-index: 1;
  }
  .eq-padlock-main {
    display: block;
    width: 100%;                            /* full-width como na oficial */
    height: auto;
    margin: 0 0 0.25rem;
    background-color: #F0E8E5;              /* bege atrás da ilustração */
    /* fade suave pro branco no rodapé da ilustração */
    -webkit-mask-image: linear-gradient(to bottom, #000 82%, transparent 100%);
    mask-image: linear-gradient(to bottom, #000 82%, transparent 100%);
    position: relative;
    z-index: 2;
  }
  .eq-progress-steps-bar {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin: 0 0 1.5rem;
    padding: 0;
    text-align: center;
    box-sizing: border-box;
  }
  .eq-step {
    flex: 1 1 0;
    width: 25%;
    min-width: 0;
    padding: 0 2px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    box-sizing: border-box;
  }
  .eq-step-label {
    font-size: 0.62rem;
    line-height: 1.1;
    color: #6f7a85;
    margin-bottom: 0.5rem;
    height: 2.7rem;
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    text-align: center;
    word-break: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
  }
  .eq-step.progress-active .eq-step-label {
    font-weight: 900;
    color: #2f3134;
  }
  /* Trilha dos marcadores: altura FIXA igual ao diâmetro do círculo (22px).
     Antes o grupo media 25.3px por causa do baseline do inline-block, então
     o top: 6px da linha nunca batia com o centro real do círculo. */
  .eq-mark-group {
    width: 100%;
    height: 22px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  /* Círculo com fundo OPACO (antes era translúcido e a linha aparecia
     atravessando por dentro do marcador). 22px já inclui a borda. */
  .eq-round-mark {
    box-sizing: border-box;
    width: 22px;
    height: 22px;
    border: 3px solid rgba(90, 18, 158, 0.25);
    border-radius: 50%;
    background: #c4aadc;                   /* equivalente opaco do roxo 35% */
    display: block;
    position: relative;
    z-index: 2;
  }
  .eq-step.progress-active .eq-round-mark {
    border-color: #5A129E;
    background: #dcccf0;
    box-shadow: 0 0 0 6px rgba(90, 18, 158, 0.196);
  }
  .eq-step.progress-done .eq-round-mark {
    border-color: #0e8608;
    background: #31E421;
    box-shadow: 0 0 0 6px rgba(14, 134, 8, 0.35);
  }
  /* Conector centrado no eixo do círculo e escondido atrás dele. */
  .eq-line-mark {
    width: 100%;
    height: 4px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%);
    margin: 0;
    background: #c4aadc;
    z-index: 1;
    pointer-events: none;
  }
  .eq-step:last-child .eq-line-mark { display: none; }
  .eq-step.progress-done .eq-line-mark { background: #0e8608; }

  /* ═══ CONTAINER & FORM BOX — réplica de #form-login oficial ════════════ */
  /* Os pais .row Bootstrap viram flex com height 0 no mobile (sem section
     wrapper). Força .painel-login a ser BLOCK width 100% pra recuperar layout. */
  .painel-login {
    display: block !important;
    flex: none !important;
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 16px env(safe-area-inset-bottom, 16px) !important;
    margin: 0 auto !important;
    box-sizing: border-box;
  }
  /* Também precisamos quebrar o flex/row do bootstrap que envolve o painel */
  .painel-login,
  .no-margin.row,
  .container {
    width: 100% !important;
    max-width: 100% !important;
  }
  /* O wrapper que estava com flex 0 0 100% precisa virar block stack vertical */
  body .no-margin.row {
    display: block !important;
  }
  .login-box {
    /* Oficial: #form-login { font-size: 1rem; border-radius: 8px;
                              background-color: white; overflow: hidden } */
    background: #ffffff !important;
    border-radius: 12px !important;
    border: 1px solid rgba(95, 96, 98, 0.18) !important;
    /* Shadow mais visível pra destacar do fundo cinza claro */
    box-shadow: 0 8px 24px rgba(20, 24, 35, 0.08),
                0 2px 6px rgba(20, 24, 35, 0.04) !important;
    margin: 24px auto !important;
    padding: 0 !important;
    overflow: hidden !important;
    max-width: 480px;
    backdrop-filter: none !important;
    -webkit-backdrop-filter: none !important;
  }
  .content-login {
    /* Override do Bootstrap col-xs-10 que dava flex 0 0 83.3333% (width 0) */
    flex: none !important;
    width: 100% !important;
    max-width: 100% !important;
    padding: 24px 24px calc(env(safe-area-inset-bottom, 16px) + 24px) !important;
    margin: 0 !important;
    background: #ffffff;
    position: relative;
    box-sizing: border-box;
  }

  /* ═══ LOGO — replicação do .logo-holder + img oficial ════════════════════ */
  /* Oficial: .logo-holder { text-align: center; margin-bottom: 6vh } */
  /* Oficial: .logo-holder img { max-width: 130px } */
  .login-box .content-login::before {
    /* Reserva espaço pro logo (caso o template não tenha logo dentro) */
    content: '';
    display: block;
    height: 0;
  }
  /* h2/h3 "Segunda via / e outros serviços" — escondidos no mobile
     porque já temos logo Equatorial + progress bar dando contexto visual. */
  .login-box h2,
  .login-box h3 {
    display: none !important;
  }
  .login-box p {
    color: #212529 !important;
    font-size: 1rem;
    margin: 0 0 1rem;
    line-height: 1.5;
  }
  .login-box p strong {
    color: #5A129E !important;            /* roxo Equatorial */
    font-weight: 700;
  }
  .login-box p.lead {
    font-size: 1.25rem !important;       /* .lead oficial */
    font-weight: 300 !important;
    margin-bottom: 1rem !important;
    color: #212529 !important;
  }
  .login-box label {
    /* Oficial: .form-label { margin-bottom: .5rem } */
    color: #212529 !important;
    font-size: 0.95rem !important;
    font-weight: 400 !important;
    text-transform: none !important;
    letter-spacing: 0;
    margin: 8px 0 6px !important;
    display: inline-block;
  }

  /* Barra rosa-pálido agora vem do .eq-bg-padlock no template (real div) */

  /* ═══ INPUTS — .form-control Bootstrap + override Equatorial ═══════════ */
  .login-box input[type="text"],
  .login-box input[type="tel"],
  .login-box input[type="email"],
  .login-box input[type="number"] {
    box-sizing: border-box !important;
    display: block !important;
    width: 100% !important;
    min-height: 48px !important;
    height: 48px !important;
    padding: 0.375rem 0.75rem !important;
    font-size: 1rem !important;           /* >= 16px evita zoom iOS */
    font-weight: 400 !important;
    line-height: 1.5 !important;
    color: #212529 !important;
    background-color: #ffffff !important;
    background-clip: padding-box !important;
    border: 1px solid rgba(95, 96, 98, 0.2) !important;
    border-radius: 0.25rem !important;    /* .form-control oficial */
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    -webkit-appearance: none !important;
    appearance: none !important;
  }
  .login-box input[type="text"]:focus,
  .login-box input[type="tel"]:focus,
  .login-box input[type="email"]:focus,
  .login-box input[type="number"]:focus {
    outline: 0 !important;
    border-color: #5A129E !important;
    box-shadow: 0 0 0 0.25rem rgba(90, 18, 158, 0.18) !important;
  }
  /* Placeholder: o tema escuro usa branco (invisível no input branco do
     mobile). Força o cinza padrão do Bootstrap. */
  .login-box input::placeholder,
  .login-box textarea::placeholder {
    color: #6c757d !important;
    opacity: 1 !important;
  }
  /* SMS code — estilo .form-control-lg */
  #smsCode {
    text-align: center !important;
    letter-spacing: 0.5em !important;
    font-size: 1.25rem !important;
    font-weight: 700 !important;
    min-height: calc(1.5em + 1rem + 2px) !important;
    padding: 0.5rem 1rem !important;
    border-radius: 0.3rem !important;
  }
  #phoneFull {
    text-align: center !important;
    font-size: 1.05rem !important;
    letter-spacing: 0.02em !important;
    font-weight: 500;
  }

  /* ═══ LINHA DE AÇÕES (Voltar + Continuar) ══════════════════════════════
     Passo CPF: réplica da oficial → "← Voltar" à esquerda + "Continuar →"
     pequeno à direita (space-between). Demais passos: botão full-width. */
  .otp-actions {
    display: flex !important;
    align-items: center;
    gap: 12px;
    margin: 1.5rem 0 14px;
  }
  .otp-actions--cpf {
    justify-content: space-between;
  }
  /* Botão "← Voltar" — branco com borda sutil (btns-back oficial).
     margin: 0 zera o "margin: 10px 0 14px" herdado do tema, que empurrava
     o Voltar 5px abaixo do Continuar. inline-flex centraliza o texto. */
  .otp-actions .btns-back {
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: auto !important;                /* tema força width:100% nos buttons */
    margin: 0 !important;
    min-height: 44px;
    padding: 0.5rem 1rem;
    border-radius: 0.6rem;
    background: #ffffff;
    border: 1px solid rgba(95, 96, 98, 0.25);
    color: #5A129E;
    font-family: inherit;
    font-size: 0.95rem;
    font-weight: 600;
    line-height: 1.4;
    cursor: pointer;
    white-space: nowrap;
    transition: background 120ms ease, border-color 120ms ease, transform 80ms ease;
    -webkit-appearance: none;
    appearance: none;
  }
  .otp-actions .btns-back:active { transform: scale(0.98); background: #f4ebff; }
  .otp-actions .btns-back:disabled { opacity: 0.5; cursor: not-allowed; }

  /* ═══ BOTÃO PRIMÁRIO — réplica EXATA do .btn-primary oficial ════════════ */
  .login-box .btn-hi {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    width: 100% !important;
    min-height: 44px !important;
    height: auto !important;
    padding: 0.5rem 0.75rem !important;
    border-radius: 0.6rem !important;     /* .btn oficial */
    font-family: inherit !important;
    font-size: 0.95rem !important;
    font-weight: 600 !important;
    line-height: 1.4 !important;
    text-align: center !important;
    text-decoration: none !important;
    text-transform: none !important;
    vertical-align: middle;
    cursor: pointer;
    user-select: none;
    background: #5A129E !important;        /* .btn-primary oficial */
    color: #ffffff !important;
    border: 1px solid #2c0a4c !important;
    box-shadow: 0 2px 6px rgba(90, 18, 158, 0.22);
    margin-top: 0 !important;             /* margem agora vem do .otp-actions */
    transition: background-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, transform 80ms ease;
    -webkit-appearance: none !important;
    appearance: none !important;
  }
  /* Passo CPF: Continuar vira pequeno (auto-width) ao lado do Voltar */
  .login-box .btn-hi.btn-hi--sm {
    width: auto !important;
    flex: 0 0 auto;
    padding: 0.5rem 1.25rem !important;
  }
  /* Dentro da .otp-actions o espaçamento vem do container (margin-bottom
     14px) — zera a margem do botão pra alinhar com o Voltar. */
  .login-box .otp-actions .btn-hi {
    margin: 0 !important;
  }
  /* Seta "→" só no mobile (CPF), sem alterar o texto compartilhado do desktop.
     Não exibe durante o loading (quando aparecem as bolinhas). */
  .login-box .btn-hi.btn-hi--sm:not(.is-loading) .btn-label::after {
    content: ' →';
  }
  .login-box .btn-hi:hover:not(:disabled) {
    background: #8116df !important;        /* hover oficial */
    color: #ffffff !important;
    box-shadow: 0 4px 10px rgba(47, 46, 121, 0.55);
  }
  .login-box .btn-hi:active {
    background: #4a0d85 !important;
    transform: scale(0.99);
  }
  .login-box .btn-hi:disabled {
    background: rgba(90, 18, 158, 0.55) !important;
    color: rgba(255, 255, 255, 0.9) !important;
    box-shadow: none;
    cursor: not-allowed;
  }
  .login-box .btn-hi.is-loading {
    background: #4a0d85 !important;
  }
  .login-box .btn-hi .btn-dots span {
    background: #ffffff;
    width: 6px;
    height: 6px;
  }

  /* ═══ SAUDAÇÃO — bloco rosa-pálido estilo confirma-cpf ════════════════ */
  .otp-greeting {
    font-size: 1rem !important;
    font-weight: 600 !important;
    color: #212529 !important;
    background: #f2f2f2;
    border-radius: 8px;
    padding: 12px 14px;
    margin: 0 0 16px !important;
    text-shadow: none;
    letter-spacing: 0;
  }
  .otp-greeting strong {
    color: #5A129E !important;
    font-weight: 700 !important;
  }
  .otp-helper {
    font-size: 0.95rem !important;
    line-height: 1.5 !important;
    color: #5f6062 !important;
    margin: 4px 0 14px;
    text-shadow: none;
  }
  .otp-helper strong {
    color: #5A129E !important;
  }

  /* ═══ CARDS DE TELEFONE ═══════════════════════════════════════════════ */
  .otp-phone-list {
    display: flex;
    flex-direction: column;
    gap: 10px !important;
    margin: 6px 0 4px !important;
  }
  .otp-phone-btn {
    box-sizing: border-box;
    min-height: 48px;
    padding: 10px 14px !important;
    border-radius: 0.7rem !important;
    font-size: 1rem !important;
    background: #ffffff !important;
    border: 1px solid rgba(95, 96, 98, 0.2) !important;
    color: #212529 !important;
    gap: 12px !important;
    box-shadow: none;
    display: flex;
    align-items: center;
    text-align: left;
    cursor: pointer;
    transition: border-color 120ms ease, background 120ms ease, transform 80ms ease;
    -webkit-appearance: none;
    appearance: none;
  }
  .otp-phone-btn .fa {
    font-size: 18px !important;
    color: #5A129E !important;
  }
  .otp-phone-btn:hover {
    border-color: #5A129E !important;
    background: #faf6ff !important;
  }
  .otp-phone-btn:active,
  .otp-phone-btn.is-selected {
    transform: scale(0.99);
    border-color: #5A129E !important;
    background: #f4ebff !important;
    box-shadow: 0 0 0 3px rgba(90, 18, 158, 0.15);
  }

  /* ═══ MODAL SHEET (contratos / faturas / PIX) ═════════════════════════ */
  .modal-service.lista-debitos-modal {
    position: fixed;
    inset: 0;
    z-index: 9990;
    display: flex;
    align-items: flex-end;
    background: rgba(44, 10, 76, 0.55);   /* backdrop roxo escuro Equatorial */
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
  }
  .modal-service.lista-debitos-modal .container {
    width: 100%;
    max-width: 100% !important;
    padding: 0 !important;
  }
  .modal-service.lista-debitos-modal .modal-content {
    background: #ffffff;
    border-radius: 30px 30px 0 0 !important;
    max-height: 92vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0 0 calc(env(safe-area-inset-bottom, 0px) + 20px);
    animation: sheetSlideUp 0.32s cubic-bezier(0.32, 0.72, 0, 1);
    box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.18);
    width: 100% !important;
    margin: 0 !important;
  }
  .modal-service.lista-debitos-modal .modal-content::before {
    content: '';
    display: block;
    width: 42px;
    height: 5px;
    background: #d6dde4;
    border-radius: 999px;
    margin: 10px auto 4px;
  }
  @keyframes sheetSlideUp {
    from { transform: translateY(100%); }
    to   { transform: translateY(0); }
  }
  .modal-service.lista-debitos-modal .modal-outter { display: none; }
  .modal-title {
    padding: 4px 18px 14px !important;
    border-bottom: 1px solid #f0f3f6;
    position: sticky;
    top: 0;
    background: #ffffff;
    z-index: 2;
  }
  .modal-title h3 {
    font-size: 1.05rem !important;
    font-weight: 700 !important;
    margin: 12px 0 0 !important;
    color: #212529;
  }

  /* X (fechar) — bolinha cinza canto direito */
  .modal-close,
  .modal-service button.modal-close {
    position: absolute !important;
    top: 14px;
    right: 14px;
    width: 36px !important;
    height: 36px !important;
    border-radius: 50% !important;
    background: #f2f2f2 !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
    color: #5f6062 !important;
    font-size: 14px !important;
    z-index: 3;
    border: none !important;
    outline: none;
    padding: 0 !important;
    margin: 0 !important;
    float: none !important;
    cursor: pointer;
    font-family: inherit;
    -webkit-appearance: none;
    appearance: none;
    transition: background 120ms ease, transform 100ms ease;
  }
  .modal-close:active,
  .modal-service button.modal-close:active {
    background: #e6eaef !important;
    transform: scale(0.94);
  }
  .modal-close:hover,
  .modal-service button.modal-close:hover {
    background: #e6eaef !important;
  }
  .modal-body { padding: 14px 16px !important; }

  /* ═══ LISTA DE CONTRATOS ══════════════════════════════════════════════ */
  .segunda-via-list, .contratos-list {
    border-collapse: separate !important;
    border-spacing: 0 10px !important;
  }
  .contratos-list tr {
    background: #ffffff;
    border: 1px solid rgba(95, 96, 98, 0.18);
    border-radius: 0.7rem;
    box-shadow: none;
    display: flex;
    flex-wrap: wrap;
    padding: 14px 14px;
    margin-bottom: 0;
    transition: border-color 120ms ease, background 120ms ease;
  }
  .contratos-list tr:active {
    background: #faf6ff;
    border-color: #5A129E;
  }
  .contratos-list td {
    border: none !important;
    padding: 4px 0 !important;
  }
  .contratos-list td.contrato-cell { flex: 0 0 60%; }
  .contratos-list td.endereco-cell { flex: 0 0 100%; padding-top: 6px !important; }
  .contratos-list td.bill-date {
    flex: 0 0 40%;
    text-align: right;
  }
  .contratos-list td.bill-date svg {
    stroke: #5A129E !important;
  }
  .contrato-numero {
    font-size: 1rem !important;
    color: #212529;
    font-weight: 700;
  }
  .contrato-label {
    font-size: 0.7rem !important;
    color: #6f7a85;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .endereco-rua    { font-size: 0.9rem !important; color: #212529; }
  .endereco-bairro { font-size: 0.78rem !important; color: #6f7a85; }

  /* ═══ LISTA DE FATURAS ═══════════════════════════════════════════════ */
  .segunda-via-list tr {
    display: grid;
    grid-template-columns: 1.4fr 1fr;
    gap: 6px 12px;
    background: #ffffff;
    border: 1px solid rgba(95, 96, 98, 0.18);
    border-radius: 0.7rem;
    padding: 14px 14px;
    box-shadow: none;
  }
  .segunda-via-list tr:active {
    background: #faf6ff;
    border-color: #5A129E;
  }
  .segunda-via-list td {
    border: none !important;
    padding: 0 !important;
    text-align: left !important;
  }
  .segunda-via-list td.bill-reference { grid-column: 1 / 2; }
  .segunda-via-list td.bill-value {
    grid-column: 2 / 3;
    text-align: right !important;
    font-size: 1.05rem;
    font-weight: 700;
    align-self: center;
    color: #212529;
  }
  .segunda-via-list td.bill-date {
    grid-column: 1 / 3;
    padding-top: 4px !important;
    color: #6f7a85;
    font-size: 0.82rem;
  }
  .segunda-via-list td span:first-child {
    text-transform: uppercase;
    font-size: 0.7rem;
    letter-spacing: 0.04em;
    color: #6f7a85;
  }
  .referencia_legada {
    font-weight: 700;
    color: #212529;
    font-size: 0.95rem;
  }
  /* Em aberto: borda lateral roxa Equatorial */
  .segunda-via-list .fatura-em-aberto {
    border-left: 4px solid #5A129E !important;
    padding-left: 14px;
  }
  .segunda-via-list .fatura-em-aberto .bill-value::before {
    content: '⚠ ';
    color: #ff0195;
    font-size: 0.78rem;
  }

  /* ═══ BOTÃO "VOLTAR CONTRATOS" — roxo Equatorial ══════════════════════ */
  .modal-back,
  .modal-service button.modal-back {
    padding: 0.375rem 0.75rem !important;
    font-size: 0.875rem !important;
    font-weight: 400 !important;
    border-radius: 0.7rem !important;
    background: #5A129E !important;
    border: 1px solid #2c0a4c !important;
    color: #ffffff !important;
    box-shadow: 0 2px 6px rgba(90, 18, 158, 0.22) !important;
    width: auto !important;
    float: none !important;
    margin: 0 !important;
    font-family: inherit !important;
    line-height: 1.5;
    display: inline-flex;
    align-items: center;
    text-align: left !important;
  }
  .modal-back:active,
  .modal-service button.modal-back:active {
    background: #4a0d85 !important;
    transform: scale(0.98);
  }
  .modal-back:hover,
  .modal-service button.modal-back:hover {
    background: #8116df !important;
    box-shadow: 0 4px 10px rgba(47, 46, 121, 0.55) !important;
  }
  .modal-back svg,
  .modal-service button.modal-back svg {
    stroke: #ffffff !important;
  }

  /* ═══ MODAL PIX ═══════════════════════════════════════════════════════ */
  .pix-modal-body { padding: 16px !important; }
  .pix-info-row {
    padding: 12px 0;
    font-size: 0.95rem;
  }
  .pix-valor {
    font-size: 1.7rem !important;
    color: #212529;
    font-weight: 700;
  }
  .pix-btn-copiar {
    min-height: 48px;
    border-radius: 0.7rem;
    font-size: 1rem;
    font-weight: 400;
    background: #5A129E !important;
    color: #ffffff !important;
    border: 1px solid #2c0a4c !important;
    box-shadow: 0 2px 6px rgba(90, 18, 158, 0.22);
  }
  .pix-btn-copiar:hover {
    background: #8116df !important;
    box-shadow: 0 4px 10px rgba(47, 46, 121, 0.55);
  }
  .pix-btn-copiar.copiado {
    background: #0e8608 !important;       /* verde sucesso oficial */
    border-color: #075a05 !important;
    color: #ffffff !important;
  }
  .pix-codigo-wrap {
    font-size: 0.75rem !important;
    padding: 12px !important;
    max-height: 88px !important;
    background: #f2f2f2;
    border-radius: 8px;
  }

  /* ═══ Loading overlay PIX ════════════════════════════════════════════ */
  .pix-loading-card {
    border-radius: 18px;
    padding: 30px 24px;
    background: rgba(255, 255, 255, 0.97);
    backdrop-filter: blur(10px);
  }
}


/* ═════════════════════════ MOBILE VERY SMALL (iPhone SE etc) ════════════ */
@media (max-width: 380px) {
  .login-box h2 { font-size: 1.05rem !important; }
  .login-box h3 { font-size: 0.78rem !important; margin-bottom: 18px !important; }
  .content-login { padding: 24px 18px calc(env(safe-area-inset-bottom, 12px) + 22px) !important; }
  .otp-phone-btn { min-height: 52px; padding: 12px 14px !important; font-size: 0.92rem !important; }
  .otp-phone-btn .fa { font-size: 18px !important; }
  .modal-title h3 { font-size: 0.95rem !important; }
  .site-logo { height: 28px; }
}

/* ═════════════════════════ Animações com prefers-reduced-motion ══════════ */
@media (prefers-reduced-motion: reduce) {
  .modal-service.lista-debitos-modal .modal-content { animation: none; }
  .otp-greeting { animation: none !important; }
  .btn-hi .btn-dots span { animation-duration: 2s !important; }
}

/* ═════════════════════════ DESKTOP — esconder elementos OTP-only ════════════
   Logo, cadeado e progress bar (.eq-*) existem APENAS para a réplica mobile do
   form OTP oficial e só têm estilo dentro de @media (max-width: 768px). No
   desktop o layout é o do header CEA original (que já tem a .site-logo branca),
   então renderizar os .eq-* aqui causava DUAS logos + cadeado/steps sem estilo.
   Mantém o desktop fiel ao design original: uma logo só. */
@media (min-width: 769px) {
  .eq-logo-holder,
  .eq-bg-padlock,
  .eq-padlock-main,
  .eq-progress-steps-bar {
    display: none !important;
  }
}
</style>

<!-- ═══════════════════════════════════════════════════════════════════════
     GLOBAL STYLES (não-scoped) — regras pra body/html/#app que precisam ser
     globais pra dar o background cinza + altura mínima no mobile.
     <style scoped> prefixa tudo com [data-v-XXX] e essas regras pra raízes
     do DOM nunca match. Daí esse <style> separado sem scoped.
     ═══════════════════════════════════════════════════════════════════════ -->
<style>
@media (max-width: 768px) {
  html, body, #app {
    background: #f4f5f7 !important;
    min-height: 100vh !important;
    margin: 0 !important;
    color: #212529 !important;
  }

  /* Cabeçalho do modal de contratos/faturas fica fixo no topo durante o
     scroll — sem isso o botão "Voltar" sai da tela na lista longa. */
  .modal-content--wide .modal-title {
    position: sticky !important;
    top: 0;
    z-index: 40;
    background: #ffffff !important;
    padding: 8px 0 6px !important;
    margin-bottom: 4px !important;
    border-bottom: 1px solid rgba(95, 96, 98, 0.14);
  }
  .modal-content--wide .modal-back {
    position: relative;
    z-index: 41;
  }
  #app > div {
    background: #f4f5f7 !important;
    min-height: 100vh !important;
    display: block !important;
    width: 100% !important;
  }
  /* O Bootstrap row legado no template force flex que zerava altura.
     Forçar block stack vertical no mobile. */
  #app .no-margin.row {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
  }
  #app .container {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 !important;
  }
  /* Painel de login full width */
  #app .painel-login {
    display: block !important;
    flex: none !important;
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 16px env(safe-area-inset-bottom, 16px) !important;
    margin: 0 auto !important;
    box-sizing: border-box;
  }
  /* Content-login (col-xs-10) precisa ser full width MAS com respiro lateral.
     Antes era padding:0, fazendo input/botão/cards encostarem nas bordas do
     card (parecia overflow). 20px laterais dão o respiro do form OTP oficial. */
  #app .content-login {
    flex: none !important;
    width: 100% !important;
    max-width: 100% !important;
    padding: 6px 20px calc(env(safe-area-inset-bottom, 16px) + 22px) !important;
    margin: 0 !important;
    box-sizing: border-box !important;
  }
}

</style>

